(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * API enum.
 */
var API_ROOT = "/api";
var API_METHOD = {
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  GET: "GET",
  DELETE: "DELETE"
};
var API_URLS = {
  FAVORITE: "".concat(API_ROOT, "/favorite/"),
  CART: "".concat(API_ROOT, "/cart/cart/"),
  COUPON: "".concat(API_ROOT, "/coupon/"),
  POINT: "".concat(API_ROOT, "/point/"),
  USERS: "".concat(API_ROOT, "/users/"),
  FFP: "".concat(API_ROOT, "/loyalty-program/")
};
var instance;
var ApiUtls = /*#__PURE__*/function () {
  /**
   * The constructor.
   */
  function ApiUtls() {
    (0, _classCallCheck2["default"])(this, ApiUtls);
    if (instance) {
      throw new Error("You can only create one instance!");
    }
    instance = this;
    if (document.querySelector("[name=csrfmiddlewaretoken]")) {
      /**
       * Global variables
       */
      this.csrfToken_;

      /**
       * Binds functions.
       */
      this.initialize_ = this.initialize_.bind(this);
      this.getInstance = this.getInstance.bind(this);
      this.setCsrfToken_ = this.setCsrfToken_.bind(this);
      this.getCsrfToken_ = this.getCsrfToken_.bind(this);
      this.call_ = this.call_.bind(this);
      this.getProductList = this.getProductList.bind(this);
      this.initialize_();
    }
  }

  /**
   * Initializes the component.
   * @private
   */
  return (0, _createClass2["default"])(ApiUtls, [{
    key: "initialize_",
    value: function initialize_() {
      this.setCsrfToken_();
    }

    /**
     * Gets current instance
     * @returns {object}
     */
  }, {
    key: "getInstance",
    value: function getInstance() {
      return this;
    }

    /**
     * Sets CSRF token
     * @private
     */
  }, {
    key: "setCsrfToken_",
    value: function setCsrfToken_() {
      try {
        this.csrfToken_ = document.querySelector("[name=csrfmiddlewaretoken]").content;
      } catch (error) {
        console.error(error);
      }
    }

    /**
     * Gets current csrf token value
     * @returns {string}
     * @private
     */
  }, {
    key: "getCsrfToken_",
    value: function getCsrfToken_() {
      return this.csrfToken_;
    }

    /**
     * Calls fetch
     * @param {string} method
     * @param {string} url
     * @param {object} params
     * @private
     */
  }, {
    key: "call_",
    value: function call_(method, url, params) {
      if (this.csrfToken_ === null) {
        this.setCsrfToken_();
      }
      var headers = {
        "x-csrftoken": this.csrfToken_,
        "content-type": "application/json"
      };
      return fetch("".concat(url), {
        method: method,
        headers: headers,
        body: JSON.stringify(params),
        credentials: "include"
      });
    }

    /**
     * Makes a HTTP GET request to given url.
     * @param {string} url
     * @returns {string}
     * @public
     */
  }, {
    key: "get",
    value: function get(url) {
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Makes a HTTP POST request to given url.
     * @param {string} url
     * @param {object} params
     * @returns {string}
     * @public
     */
  }, {
    key: "post",
    value: function post(url, params) {
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Adds or removes the product from use's favorite
     * @param {object} params with item_id, or item_matrix_id. if need delete, add {delete:true}
     * @returns {string}
     * @public
     */
  }, {
    key: "favoriteProduct",
    value: function favoriteProduct(params) {
      var url = "".concat(API_URLS.FAVORITE, "product/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Retrives user favorite products.
     * @public
     */
  }, {
    key: "getFavoriteList",
    value: function getFavoriteList() {
      var url = "".concat(API_URLS.FAVORITE, "list/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Add product to use's cart
     * @param {object} params with item_id ,quantity
      };
     * @returns {string}
     * @public
     */
  }, {
    key: "addProduct",
    value: function addProduct(params) {
      var url = "".concat(API_URLS.CART, "add/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Retrives product list.
     * @public
     */
  }, {
    key: "getProductList",
    value: function getProductList(url) {
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives user cart products.
     * @public
     */
  }, {
    key: "getCartList",
    value: function getCartList() {
      return this.call_(API_METHOD.GET, API_URLS.CART);
    }

    /**
     * Delete user cart line-product.
     * @public
     */
  }, {
    key: "deleteCartList",
    value: function deleteCartList(params) {
      var url = "".concat(API_URLS.CART, "delete-line/");
      return this.call_(API_METHOD.DELETE, url, params);
    }

    /**
     * Retrives user cart details.
     * @public
     */
  }, {
    key: "getCartDetails",
    value: function getCartDetails() {
      var url = "".concat(API_URLS.CART, "detail/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives cart product inventories.
     * @public
     */
  }, {
    key: "getCartInventories",
    value: function getCartInventories() {
      var url = "".concat(API_URLS.CART, "detail/inventories/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives cart ffp.
     * @public
     */
  }, {
    key: "getCartFreeFoodProgram",
    value: function getCartFreeFoodProgram() {
      var url = "".concat(API_URLS.CART, "detail/ffp/available/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives cart up sell (add on).
     * @public
     */
  }, {
    key: "getCartAddOn",
    value: function getCartAddOn() {
      var url = "".concat(API_URLS.CART, "add-on/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives user membership.
     * @public
     */
  }, {
    key: "getMembershipDetails",
    value: function getMembershipDetails() {
      var url = "".concat(API_URLS.CART, "membership/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Retrives cart up coupon.
     * @public
     */
  }, {
    key: "getCoupons",
    value: function getCoupons() {
      var url = "".concat(API_URLS.COUPON, "available/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Updated cart line, including upsell line
     * @public
     */
  }, {
    key: "updateCartLine",
    value: function updateCartLine(params) {
      var url = "".concat(API_URLS.CART, "detail/update-line/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Updated cart line.
     * @public
     */
  }, {
    key: "deleteCartLine",
    value: function deleteCartLine(params) {
      var url = "".concat(API_URLS.CART, "detail/delete-line/");
      return this.call_(API_METHOD.DELETE, url, params);
    }

    /**
     * Updates cart line.
     * @public
     */
  }, {
    key: "updateShippingMethod",
    value: function updateShippingMethod(params) {
      var url = "".concat(API_URLS.CART, "detail/shipping-method/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Updates promo code.
     * @public
     */
  }, {
    key: "updatePromoCode",
    value: function updatePromoCode(params) {
      var url = "".concat(API_URLS.CART, "detail/promo-code/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Updates coupon item.
     * @public
     */
  }, {
    key: "updateCoupon",
    value: function updateCoupon(params) {
      var url = "".concat(API_URLS.CART, "detail/coupon/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Updates cart ffp.
     * @public
     */
  }, {
    key: "updateCartFreeFoodProgram",
    value: function updateCartFreeFoodProgram(params) {
      var url = "".concat(API_URLS.CART, "detail/ffp-lines/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * action of order by paypal
     * @public
     */
  }, {
    key: "paypalOrder",
    value: function paypalOrder(url, params) {
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * action of order by moneris checkout payment
     * @public
     */
  }, {
    key: "monerisCheckoutCall",
    value: function monerisCheckoutCall(url, params) {
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Get user point status.
     * @public
     */
  }, {
    key: "getUserPoint",
    value: function getUserPoint() {
      var url = "".concat(API_URLS.POINT, "my-status/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Redeem user points for coupon.
     * @public
     */
  }, {
    key: "redeemUserPoint",
    value: function redeemUserPoint() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = "".concat(API_URLS.POINT, "redeem/");
      return this.call_(API_METHOD.POST, url, params);
    }

    /**
     * Check if user already subscribe email
     * @public
     */
  }, {
    key: "emailSubscribeCheck",
    value: function emailSubscribeCheck() {
      var url = "".concat(API_URLS.USERS, "email-subscribe/check-show/");
      return this.call_(API_METHOD.GET, url);
    }

    /**
     * Saves modal status already show
     * @public
     */
  }, {
    key: "emailSubscribeCancel",
    value: function emailSubscribeCancel() {
      var url = "".concat(API_URLS.USERS, "email-subscribe/cancel-show/");
      return this.call_(API_METHOD.POST, url);
    }

    /**
     * Redeems item for Free Food program (loyalty program)
     * @public
     */
  }, {
    key: "redeemItemAdmin",
    value: function redeemItemAdmin(params) {
      var url = "".concat(API_URLS.FFP, "admin-redeem-item/");
      return this.call_(API_METHOD.POST, url, params);
    }
  }]);
}();
var apiUtils = Object.freeze(new ApiUtls());
var _default = exports["default"] = apiUtils;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeToastsOfType = removeToastsOfType;
exports.showBootstrapToast = showBootstrapToast;
exports.showCartOffcanvas = showCartOffcanvas;
exports.showFavOffcanvas = showFavOffcanvas;
function showCartOffcanvas() {
  if (document.querySelector("#offcanvas-cart")) {
    var cartOffcanvas = bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart");
    cartOffcanvas.show();
  }
}
function showFavOffcanvas() {
  if (document.querySelector("#offcanvas-wishlist")) {
    var wishlistOffcanvas = bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-wishlist");
    wishlistOffcanvas.show();
  }
}
function showBootstrapToast(message) {
  var toastBgClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "text-bg-danger";
  var toastType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var toastDiv = document.createElement("div");
  toastDiv.className = "toast ".concat(toastBgClass, " border-0");
  if (toastType) {
    toastDiv.setAttribute("data-toast-type", toastType);
  }
  toastDiv.setAttribute("role", "alert");
  toastDiv.setAttribute("aria-live", "assertive");
  toastDiv.setAttribute("aria-atomic", "true");

  /* Create the inner d-flex div */
  var dFlexDiv = document.createElement("div");
  dFlexDiv.className = "d-flex";

  /* Create the toast-body div and set its content */
  var toastBodyDiv = document.createElement("div");
  toastBodyDiv.className = "toast-body";
  toastBodyDiv.textContent = message;

  /* Create the button for closing the toast */
  var closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "btn-close btn-close-white me-2 m-auto";
  closeButton.setAttribute("data-bs-dismiss", "toast");
  closeButton.setAttribute("aria-label", "Close");

  /* Append the toast-body and button to the d-flex div */
  dFlexDiv.appendChild(toastBodyDiv);
  dFlexDiv.appendChild(closeButton);

  /* Append the d-flex div to the main toast div */
  toastDiv.appendChild(dFlexDiv);
  var bsToast = bootstrap.Toast.getOrCreateInstance(toastDiv);
  bsToast.show();

  /* Append the whole toast div to a container */
  var toastContainer = document.querySelector("[data-anchor='notifications']");
  toastContainer.appendChild(toastDiv);
}

/* Add this function to remove particular toast */
function removeToastsOfType(toastType) {
  /* query all toast inside data-anchor="notifications" and remove the toast of the same type */
  var toastContainer = document.querySelector("[data-anchor='notifications']");
  var toastsArray = toastContainer.querySelectorAll("[data-toast-type]");
  toastsArray.forEach(function (toastElemente) {
    var currentToastType = toastElemente.getAttribute("data-toast-type");
    if (currentToastType === toastType) {
      var bsToast = bootstrap.Toast.getOrCreateInstance(toastElemente);
      bsToast.hide(); // Properly hide using Bootstrap's method
    }
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(element) {
  var buttonEl = document.querySelector("[data-bs-target=\"#".concat(element.getAttribute("id"), "\"]"));
  element.addEventListener("show.bs.collapse", function () {
    var shownText = element.getAttribute("data-show");
    buttonEl.textContent = shownText;
  });
  element.addEventListener("hide.bs.collapse", function () {
    var shownText = element.getAttribute("data-hide");
    buttonEl.textContent = shownText;
  });
};

},{}],4:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var CountdownRedirect = /*#__PURE__*/function () {
  /**
   * Initializes the countdown redirect and progress bar.
   * @param {Element} element - The main countdown element with data-redirect attribute.
   */
  function CountdownRedirect(element) {
    (0, _classCallCheck2["default"])(this, CountdownRedirect);
    this.element = element;
    this.countdownDuration = parseInt(this.element.getAttribute("data-countdown"), 10) || 10000;
    this.redirectUrl = this.element.getAttribute("data-redirect") || "/";
    this.progressBar = this.element.querySelector("[data-countdown='progressbar']");
    this.intervalId = null;
    this.startCountdown();
  }

  /**
   * Starts the countdown and updates the progress bar.
   */
  return (0, _createClass2["default"])(CountdownRedirect, [{
    key: "startCountdown",
    value: function startCountdown() {
      var _this = this;
      var elapsedTime = 0;
      this.intervalId = setInterval(function () {
        elapsedTime += 10;
        var remainingTime = _this.countdownDuration - elapsedTime;

        // Calculate the progress as a percentage
        var progressPercentage = Math.max(remainingTime / _this.countdownDuration * 100, 0);
        _this.progressBar.style.width = "".concat(progressPercentage, "%");

        // When time is up, redirect and clear the interval
        if (remainingTime <= 0) {
          clearInterval(_this.intervalId);
          window.location.href = _this.redirectUrl;
        }
      }, 10);
    }
  }]);
}();
var _default = exports["default"] = CountdownRedirect;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],5:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _flatpickr = _interopRequireDefault(require("flatpickr"));
var _utils = require("../shared/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * The component"s selectors.
 */
var SELECTORS = {
  options: "data-flatpicker",
  disableWeek: "data-flatpicker-disable-week"
};
var DatepickerFlatpicker = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function DatepickerFlatpicker(element) {
    (0, _classCallCheck2["default"])(this, DatepickerFlatpicker);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;
    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.initFlatpicker_ = this.initFlatpicker_.bind(this);
    this.disableWeek_ = this.disableWeek_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(DatepickerFlatpicker, [{
    key: "initialize_",
    value: function initialize_() {
      this.initFlatpicker_();
    }

    /**
     * init the flatpiker (datepicker)
     */
  }, {
    key: "initFlatpicker_",
    value: function initFlatpicker_() {
      var options = this.element_.getAttribute(SELECTORS.options);
      if (options) {
        var flapOptions = JSON.parse(options);
        var weekOption = this.element_.getAttribute(SELECTORS.disableWeek);
        if (weekOption) {
          var _flapOptions;
          flapOptions = _objectSpread(_objectSpread({}, flapOptions), this.disableWeek_(weekOption, (_flapOptions = flapOptions) === null || _flapOptions === void 0 ? void 0 : _flapOptions.disable));
        }
        (0, _flatpickr["default"])(this.element_, flapOptions);
      }
    }

    /**
     * The custom disable week function, with disable date given
     * @param {Array} disableWeek week array, Sun = 0, Mon = 1 ...
     * @param {Array} originalDisable string array, ex. ['2023-01-01']
     * @returns Object with new disable object
     */
  }, {
    key: "disableWeek_",
    value: function disableWeek_(disableWeek, originalDisable) {
      var newDisable = {
        "disable": [function (date) {
          /* Check if the day of the week is in disableWeek */
          var formatedDate = (0, _utils.formatDateYYYYMMDD)(date);
          if (disableWeek.includes(date.getDay())) {
            return true;
          }

          /* Check if the date is in originalDisable */
          if (originalDisable.includes(formatedDate)) {
            return true;
          }
        }]
      };
      return newDisable;
    }
  }]);
}();
var _default = exports["default"] = DatepickerFlatpicker;

},{"../shared/utils":27,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/defineProperty":33,"@babel/runtime/helpers/interopRequireDefault":34,"flatpickr":44}],6:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component"s block class.
 */
var SELECTORS = {
  inputPetTypeRadio: "[data-pet-type-radio]",
  formEle: "[data-food-calculator-form]",
  textPetType1: "[data-pet-type1]",
  textPetType2: "[data-pet-type2]",
  bgImage: "[data-pet-bg-img]",
  bgColor: "[data-pet-bg-color]",
  petType: "data-food-calculator-pet-type"
};
/**
 * The classes' block class
 */
var CLASSES = {
  startCenter: "start-50"
};
var FoodCalculator = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function FoodCalculator(element) {
    (0, _classCallCheck2["default"])(this, FoodCalculator);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * The component"s wrapper.
      */
    this.petTypeRadioInputs_ = this.element_.querySelectorAll(SELECTORS.inputPetTypeRadio);
    this.formElement_ = this.element_.querySelector(SELECTORS.formEle);
    this.petType1Text_ = this.element_.querySelectorAll(SELECTORS.textPetType1);
    this.petType2Text_ = this.element_.querySelectorAll(SELECTORS.textPetType2);
    this.petHolderImage_ = this.element_.querySelector(SELECTORS.bgImage);
    this.petHolderColor_ = this.element_.querySelector(SELECTORS.bgColor);

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.handleModalShow_ = this.handleModalShow_.bind(this);
    this.handleModalHide_ = this.handleModalHide_.bind(this);
    this.initValueOfPet_ = this.initValueOfPet_.bind(this);
    this.handlePetTypeChange_ = this.handlePetTypeChange_.bind(this);
    this.handleFormArrange_ = this.handleFormArrange_.bind(this);
    this.handleFormPost_ = this.handleFormPost_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(FoodCalculator, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      this.handleModalShow_();
      this.handleModalHide_();
      var initPetType = this.element_.getAttribute(SELECTORS.petType);
      if (initPetType) {
        this.initValueOfPet_(initPetType);
      }
      this.petTypeRadioInputs_.forEach(function (petRadio) {
        petRadio.addEventListener("change", function () {
          /* use value (string) to chanage the background */
          _this.handlePetTypeChange_(petRadio.value);
        });
      });
      this.formElement_.addEventListener("submit", function (event) {
        event.preventDefault();
        _this.handleFormArrange_();
      });
    }

    /**
     * show modal by default
     */
  }, {
    key: "handleModalShow_",
    value: function handleModalShow_() {
      var url = new URL(window.location.href);

      /* Remove all parameters after the question mark */
      if (url.search === "") {
        var calculatorModal = bootstrap.Modal.getOrCreateInstance(this.element_);
        calculatorModal.show();
      }
    }

    /**
     * As modal hide, and no parameters(not form submit yet). Go back to previous page
     */
  }, {
    key: "handleModalHide_",
    value: function handleModalHide_() {
      this.element_.addEventListener("hide.bs.modal", function () {
        var url = new URL(window.location.href);
        if (url.search === "") {
          window.history.go(-1);
        }
      });
    }

    /**
     * add function for init pet type
     */
  }, {
    key: "initValueOfPet_",
    value: function initValueOfPet_(initPetType) {
      this.petTypeRadioInputs_.forEach(function (petRadio) {
        if (petRadio.id === initPetType) {
          petRadio.checked = true;
        }
      });
      this.handlePetTypeChange_(initPetType);
    }

    /**
     * Changes the text accroding to the user select
     * @param {element} petRadio the key string to chcange, accept: ['cat', 'dog]
     */
  }, {
    key: "handlePetTypeChange_",
    value: function handlePetTypeChange_(petKey) {
      var petTypeMapping = {
        "dog": {
          text1: "dog",
          text2: "puppy",
          image: "bg-dog.jpg"
        },
        "cat": {
          text1: "cat",
          text2: "kitten",
          image: "bg-cat.jpg"
        }
      };
      this.petType1Text_.forEach(function (element) {
        element.textContent = petTypeMapping[petKey]["text1"];
      });
      this.petType2Text_.forEach(function (element) {
        element.textContent = petTypeMapping[petKey]["text2"];
      });

      /* Update image */
      var imagePath = "/static/images/calculator/".concat(petTypeMapping[petKey]["image"]);
      this.petHolderImage_.style.backgroundImage = "url(".concat(imagePath, ")");
      this.petHolderImage_.classList.toggle(CLASSES.startCenter, petKey === "cat");

      /* Update classes for color background */
      this.petHolderColor_.classList.toggle(CLASSES.startCenter, petKey === "dog");
    }

    /**
     * Calculates ideal weight
     */
  }, {
    key: "handleFormArrange_",
    value: function handleFormArrange_() {
      var formData = new FormData(this.formElement_);
      var currentWeight = parseFloat(formData.get("currentWeight"));
      var idealWeight = parseFloat(formData.get("idealWeight"));
      var age = parseFloat(formData.get("age"));
      var totalDailyIntake = 0;
      if (age < 1) {
        totalDailyIntake = currentWeight * 0.04;
      } else {
        if (currentWeight > idealWeight) {
          totalDailyIntake = idealWeight * 0.02; /* Total daily intake for weight loss */
        } else if (currentWeight === idealWeight) {
          totalDailyIntake = idealWeight * 0.025; /* Total daily intake for maintaining weight */
        } else {
          totalDailyIntake = idealWeight * 0.035; /* Total daily intake for weight gain */
        }
      }
      var achievedIntake = idealWeight * 0.025;
      formData.append("totalDailyIntake", totalDailyIntake);
      formData.append("achievedIntake", achievedIntake);
      this.handleFormPost_(formData);
    }

    /**
     * Post to backend with all form data
     * @param {FormData} formData original formdata with calculated data
     */
  }, {
    key: "handleFormPost_",
    value: function handleFormPost_(formData) {
      var values = (0, _toConsumableArray2["default"])(formData.entries());
      var petType = formData.get("petType", "dog");
      var age = formData.get("age", "0");
      var currentWeight = formData.get("currentWeight", "0");
      var idealWeight = formData.get("idealWeight", "0");
      var achievedIntake = formData.get("achievedIntake", "0");
      var queryForm = new FormData();
      var url = this.element_.dataset.dogUrl;
      if (petType === "cat") {
        url = this.element_.dataset.catUrl;
      }
      for (var i = 0; i < values.length; i++) {
        var key = values[i][0];
        var value = values[i][1];
        if (key === "exclude") {
          queryForm.append("exclude", value);
        }
        if (key === "source") {
          queryForm.append("source", value);
        }
        if (key === "current_food") {
          queryForm.append("current_food", value);
        }
      }
      var totalDailyIntake = formData.get("totalDailyIntake");
      queryForm.append("intake_lbs", totalDailyIntake);
      queryForm.append("age", age);
      queryForm.append("current_weight_lbs", currentWeight);
      queryForm.append("ideal_weight_lbs", idealWeight);
      queryForm.append("achieved_intake_lbs", achievedIntake);
      var queryString = new URLSearchParams(queryForm).toString();
      window.location.href = url + "?" + queryString;
    }
  }]);
}();
var _default = exports["default"] = FoodCalculator;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/helpers/toConsumableArray":38}],7:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */
/**
 * The component's selectors.
 */
var GoPreviousPage = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function GoPreviousPage(element) {
    (0, _classCallCheck2["default"])(this, GoPreviousPage);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;
    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.goBack_ = this.goBack_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(GoPreviousPage, [{
    key: "initialize_",
    value: function initialize_() {
      this.element_.addEventListener("click", this.goBack_);
    }

    /**
    * Navigates to the previous page.
    * @private
    */
  }, {
    key: "goBack_",
    value: function goBack_(event) {
      event.preventDefault(); // Prevent the default anchor behavior
      window.history.back(); // Navigate to the previous page
    }
  }]);
}();
var _default = exports["default"] = GoPreviousPage;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],8:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("./api-utils"));
var _bootstrapElement = require("./bootstrap-element");
/**
 * The component's block class.
 */
/**
 * The component's selectors.
 */
var HandleAdminRedeem = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function HandleAdminRedeem(element) {
    (0, _classCallCheck2["default"])(this, HandleAdminRedeem);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Global variables
      */

    /**
      * The component's wrapper.
      */
    this.forms_ = this.element_.querySelectorAll("[data-mlp-redeem-form='submit']");
    this.submitBtns_ = this.element_.querySelectorAll("[datat-mlp-form-btn='redeem']");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.redeemItems_ = this.redeemItems_.bind(this);
    this.needDisabledAllSubmitBtn_ = this.needDisabledAllSubmitBtn_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(HandleAdminRedeem, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      this.forms_.forEach(function (redeemForm_) {
        redeemForm_.addEventListener("submit", function (event) {
          return _this.redeemItems_(event, redeemForm_);
        });
      });
    }

    /**
     * Submits form
     * @param {element} redeemForm element of html form
     */
  }, {
    key: "redeemItems_",
    value: (function () {
      var _redeemItems_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event, redeemForm) {
        var currentFormBtn, formData, postData, response, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              this.needDisabledAllSubmitBtn_(true);
              currentFormBtn = redeemForm.querySelector("[datat-mlp-form-btn='redeem']");
              currentFormBtn.innerText = "Processing...";
              _context.prev = 4;
              formData = new FormData(redeemForm);
              postData = {
                user: formData.get("user"),
                program: formData.get("program"),
                item: formData.get("item")
              };
              _context.next = 9;
              return _apiUtils["default"].redeemItemAdmin(postData);
            case 9:
              response = _context.sent;
              _context.next = 12;
              return response.json();
            case 12:
              result = _context.sent;
              if (!response.ok) {
                _context.next = 18;
                break;
              }
              (0, _bootstrapElement.showBootstrapToast)("Success - ".concat(result.detailg, "\n (Refresh page in 5 seconds ...)"), "text-bg-success");
              setTimeout(function () {
                location.reload();
              }, 5000);
              _context.next = 19;
              break;
            case 18:
              throw result.detail;
            case 19:
              _context.next = 24;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](4);
              (0, _bootstrapElement.showBootstrapToast)("Failed - ".concat(_context.t0));
            case 24:
              _context.prev = 24;
              currentFormBtn.innerText = "Redeem";
              this.needDisabledAllSubmitBtn_(false);
              return _context.finish(24);
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[4, 21, 24, 28]]);
      }));
      function redeemItems_(_x, _x2) {
        return _redeemItems_.apply(this, arguments);
      }
      return redeemItems_;
    }()
    /**
     * Disabled all submit form button
     * @param {boolean} isNeedDisabled use true to disable, else enable base on datat-mlp-available-items-count
     */
    )
  }, {
    key: "needDisabledAllSubmitBtn_",
    value: function needDisabledAllSubmitBtn_(isNeedDisabled) {
      if (isNeedDisabled) {
        this.submitBtns_.forEach(function (submitBtn) {
          submitBtn.disabled = true;
        });
      } else {
        /* set to default value */
        this.submitBtns_.forEach(function (submitBtn) {
          submitBtn.disabled = Number.parseInt(submitBtn.getAttribute("data-mlp-available-items-count")) <= 0;
        });
      }
    }
  }]);
}();
var _default = exports["default"] = HandleAdminRedeem;

},{"./api-utils":1,"./bootstrap-element":2,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],9:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */
var CLASSES = {
  "hide": "d-none"
};

/**
 * The component's selectors.
 */
var HandleStaticItemsShowMore = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function HandleStaticItemsShowMore(element) {
    (0, _classCallCheck2["default"])(this, HandleStaticItemsShowMore);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Global variables
      */
    this.previewItems = this.element_.getAttribute("data-mlp-perview");

    /**
      * The component's wrapper.
      */
    this.showMoreWrapper_ = this.element_.querySelector("[data-mlp-more='wrapper']");
    this.showMoreBtn_ = this.showMoreWrapper_.querySelector("[data-mlp-more=\"button\"]");
    this.hiddenElements_ = this.element_.querySelectorAll("[data-mlp-item=\"wrapper\"].".concat(CLASSES.hide));

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.showAnotherItems_ = this.showAnotherItems_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(HandleStaticItemsShowMore, [{
    key: "initialize_",
    value: function initialize_() {
      this.showMoreBtn_.addEventListener("click", this.showAnotherItems_);
    }
  }, {
    key: "showAnotherItems_",
    value: function showAnotherItems_() {
      for (var i = 0; i < this.previewItems && i < this.hiddenElements_.length; i++) {
        this.hiddenElements_[i].classList.remove(CLASSES.hide);
      }
      /* Reset current hidden element */
      this.hiddenElements_ = this.element_.querySelectorAll("[data-mlp-item=\"wrapper\"].".concat(CLASSES.hide));
      if (this.hiddenElements_[0]) {
        /* if still hide some items */
        this.hiddenElements_[0].before(this.showMoreWrapper_);
      } else {
        /* remove it */
        this.showMoreWrapper_.remove();
      }
    }
  }]);
}();
var _default = exports["default"] = HandleStaticItemsShowMore;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],10:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("../components/api-utils"));
var HandleSubscribeModal = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function HandleSubscribeModal(element) {
    (0, _classCallCheck2["default"])(this, HandleSubscribeModal);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * The component"s wrapper.
      */
    this.signupPromoModalEl = bootstrap.Modal.getOrCreateInstance(this.element_);
    this.hideElement_ = this.element_.querySelector("[data-mlp-subscribe-modal=\"hideAction\"]");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.showModalCheck_ = this.showModalCheck_.bind(this);
    this.onCancelModal_ = this.onCancelModal_.bind(this);
    this.userInteraction_ = this.userInteraction_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(HandleSubscribeModal, [{
    key: "initialize_",
    value: function initialize_() {
      this.signupPromoModalEl._element.addEventListener("hidden.bs.modal", this.onCancelModal_);
      // this.hideElement_.addEventListener("click", this.onCancelModal_);
      /* Attach the event listeners for user interaction (scroll/click) */
      window.addEventListener("scroll", this.userInteraction_, {
        once: true
      });
    }

    /**
     * Handle user interaction (scroll or click) to trigger modal check.
     * @private
     */
  }, {
    key: "userInteraction_",
    value: function userInteraction_() {
      // Execute the modal check after user interaction
      this.showModalCheck_();
    }

    /**
     * Checks if need show modal
     * @private
     */
  }, {
    key: "showModalCheck_",
    value: (function () {
      var _showModalCheck_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var response, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _apiUtils["default"].emailSubscribeCheck();
            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.json();
            case 6:
              data = _context.sent;
              /* show modal if result is true */
              if (data.result) {
                this.signupPromoModalEl.show();
                /* Remove scroll listener to prevent future triggers */
                window.removeEventListener("scroll", this.userInteraction_);
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error("Error fetching data:", _context.t0);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function showModalCheck_() {
        return _showModalCheck_.apply(this, arguments);
      }
      return showModalCheck_;
    }()
    /**
     * Call cancel-show if the modal was closed by user (no matter it's clicked or "Cancel" or "X" button)
     * @private
     */
    )
  }, {
    key: "onCancelModal_",
    value: (function () {
      var _onCancelModal_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _apiUtils["default"].emailSubscribeCancel();
            case 3:
              // Ensure scroll listener is removed to prevent future shows
              window.removeEventListener("scroll", this.userInteraction_);
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.error("Error cancelling data:", _context2.t0);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function onCancelModal_() {
        return _onCancelModal_.apply(this, arguments);
      }
      return onCancelModal_;
    }())
  }]);
}();
var _default = exports["default"] = HandleSubscribeModal;

},{"../components/api-utils":1,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],11:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function initializeSwiper(swiperEl) {
  var swiperData = swiperEl.getAttribute("data-swiper");
  if (swiperData) {
    var swiperOptions = JSON.parse(swiperData);
    /** https://swiperjs.com/swiper-api#param-loop
    Because of nature of how the loop mode works (it will rearrange slides), total number of slides must be:
    more than or equal to `slidesPerView + slidesPerGroup` */
    new Swiper(swiperEl, swiperOptions);
  }
}
var _default = exports["default"] = function _default() {
  /* NOTE: item.length muse greater than slidesPerView_value*2 */
  (0, _toConsumableArray2["default"])(document.querySelectorAll("[data-swiper]")).map(function (element) {
    initializeSwiper(element);
  });
};

},{"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/helpers/toConsumableArray":38}],12:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("../components/api-utils"));
/**
 * The component's block class.
 */
/**
 * The component's selectors.
 */
var PaymentMethod = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function PaymentMethod(element) {
    (0, _classCallCheck2["default"])(this, PaymentMethod);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Global variables
      */
    this.countDownTime_ = new Date(element.dataset.paymentExpired).getTime();
    this.countDownInterval_ = null;

    /**
      * The component's wrapper.
      */
    this.countDownEle_ = this.element_.querySelector("[data-payment-countdown-text]");
    this.monerisCheckoutModalEle_ = this.element_.querySelector("#monerisCheckoutModal");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.countDownFunc_ = this.countDownFunc_.bind(this);
    this.doCancelOrder_ = this.doCancelOrder_.bind(this);
    this.monerisCheckoutInitialize_ = this.monerisCheckoutInitialize_.bind(this);
    this.monerisCheckoutHandler_ = this.monerisCheckoutHandler_.bind(this);
    this.monerisCheckoutPageLoaded_ = this.monerisCheckoutPageLoaded_.bind(this);
    this.monerisCheckoutUserBack_ = this.monerisCheckoutUserBack_.bind(this);
    this.monerisCheckoutCancelled_ = this.monerisCheckoutCancelled_.bind(this);
    this.monerisCheckoutCompleted_ = this.monerisCheckoutCompleted_.bind(this);
    this.monerisCheckoutError_ = this.monerisCheckoutError_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(PaymentMethod, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      this.countDownInterval_ = setInterval(this.countDownFunc_, 1000);
      this.monerisCheckoutModalEle_.addEventListener("shown.bs.modal", function () {
        setTimeout(function () {
          _this.monerisCheckoutInitialize_();
        }, 1000);
      });
      this.monerisCheckoutModalEle_.addEventListener("hide.bs.modal", function () {
        _this.monerisCheckoutCancelled_();
      });
    }
  }, {
    key: "countDownFunc_",
    value: function countDownFunc_() {
      var now = new Date().getTime();
      var distance = this.countDownTime_ - now;
      var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
      var seconds = Math.floor(distance % (1000 * 60) / 1000);
      this.countDownEle_.innerHTML = "" + minutes + "m " + seconds + "s ";
      if (distance < 0) {
        clearInterval(this.countDownInterval_);
        this.countDownEle_.innerHTML = "EXPIRED";
        // do cancel sale.
        this.doCancelOrder_();
      }
    }
  }, {
    key: "doCancelOrder_",
    value: function doCancelOrder_() {
      var cancelOrderForm = document.getElementById("cancelOrderForm");
      if (cancelOrderForm) {
        cancelOrderForm.submit();
      }
    }
  }, {
    key: "monerisCheckoutInitialize_",
    value: function () {
      var _monerisCheckoutInitialize_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var url, token, mode, response, result, ticket, myCheckout;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = this.element_.dataset.monerisCheckoutInitializeUrl;
              token = this.element_.dataset.monerisCheckoutToken;
              mode = this.element_.dataset.monerisCheckoutMode;
              _context.next = 5;
              return _apiUtils["default"].monerisCheckoutCall(url, {
                token: token
              });
            case 5:
              response = _context.sent;
              _context.next = 8;
              return response.json();
            case 8:
              result = _context.sent;
              ticket = result.ticket;
              myCheckout = new monerisCheckout(); // bind handlers
              myCheckout.setCallback("page_loaded", this.monerisCheckoutPageLoaded_);
              myCheckout.setCallback("cancel_transaction", this.monerisCheckoutUserBack_);
              myCheckout.setCallback("payment_receipt", this.monerisCheckoutHandler_);
              myCheckout.setCallback("payment_complete", this.monerisCheckoutCompleted_);
              myCheckout.setCallback("page_closed", this.monerisCheckoutHandler_);
              myCheckout.setCallback("payment_submitted", this.monerisCheckoutHandler_);
              myCheckout.setCallback("error_event", this.monerisCheckoutError_);

              // start checkout screen
              myCheckout.setMode(mode);
              myCheckout.setCheckoutDiv("monerisCheckoutMain");
              myCheckout.startCheckout(ticket);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function monerisCheckoutInitialize_() {
        return _monerisCheckoutInitialize_.apply(this, arguments);
      }
      return monerisCheckoutInitialize_;
    }()
  }, {
    key: "monerisCheckoutPageLoaded_",
    value: function monerisCheckoutPageLoaded_() {
      // Hide loading indicator
      var loadingIndicatorEle = this.monerisCheckoutModalEle_.querySelector("[data-moneris-checkout-loading]");
      if (loadingIndicatorEle) {
        loadingIndicatorEle.classList.add("d-none");
      }

      // Show moneris checkout screen
      var checkoutOuter = this.monerisCheckoutModalEle_.querySelector("[data-moneris-checkout-outer]");
      if (checkoutOuter) {
        checkoutOuter.classList.remove("d-none");
      }

      // calculate height for moneris checkout content.
      var checkoutHeight = 400; // default value
      var modalDialog = this.monerisCheckoutModalEle_.querySelector(".modal-dialog");
      if (modalDialog) {
        var modalBodyPadding = 32 + 6;
        checkoutHeight = modalDialog.offsetHeight - modalBodyPadding;
      }
      var checkoutMain = this.monerisCheckoutModalEle_.querySelector("[data-moneris-checkout-main]");
      if (checkoutMain) {
        checkoutMain.style.height = "" + checkoutHeight + "px";
      }
    }

    /** 
     *  Callback function for user click "Back" on moneris checkout page.
     */
  }, {
    key: "monerisCheckoutUserBack_",
    value: function monerisCheckoutUserBack_() {
      // Hide checkout model.
      var modalDialog = bootstrap.Modal.getOrCreateInstance(this.monerisCheckoutModalEle_);
      if (modalDialog) {
        modalDialog.hide();
      }
    }
  }, {
    key: "monerisCheckoutCancelled_",
    value: function monerisCheckoutCancelled_() {
      // Hide major checkout screen
      var checkoutOuter = this.monerisCheckoutModalEle_.querySelector("[data-moneris-checkout-outer]");
      if (checkoutOuter) {
        checkoutOuter.classList.add("d-none");
      }

      // Show loading indicator
      var loadingIndicatorEle = this.monerisCheckoutModalEle_.querySelector("[data-moneris-checkout-loading]");
      if (loadingIndicatorEle) {
        loadingIndicatorEle.classList.remove("d-none");
      }
    }
  }, {
    key: "monerisCheckoutCompleted_",
    value: function () {
      var _monerisCheckoutCompleted_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var url, token, response, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = this.element_.dataset.monerisCheckoutCompleteUrl;
              token = this.element_.dataset.monerisCheckoutToken;
              _context2.next = 4;
              return _apiUtils["default"].monerisCheckoutCall(url, {
                token: token
              });
            case 4:
              response = _context2.sent;
              _context2.next = 7;
              return response.json();
            case 7:
              result = _context2.sent;
              if (result.success) {
                window.location.href = result.url;
              }
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function monerisCheckoutCompleted_() {
        return _monerisCheckoutCompleted_.apply(this, arguments);
      }
      return monerisCheckoutCompleted_;
    }()
  }, {
    key: "monerisCheckoutError_",
    value: function monerisCheckoutError_(error) {
      var logColor = "padding:2px 5px;color:White;background-color:SlateBlue;";
      console.log("%c [Moneris Checkout] Error: ", logColor, error);
    }
  }, {
    key: "monerisCheckoutHandler_",
    value: function monerisCheckoutHandler_(result) {
      var logColor = "padding:2px 5px;color:White;background-color:SlateBlue;";
      console.log("%c [Moneris Checkout] Handler: ", logColor, result);
    }
  }]);
}();
var _default = exports["default"] = PaymentMethod;

},{"../components/api-utils":1,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],13:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var PaymentPageStepNavigator = /*#__PURE__*/function () {
  function PaymentPageStepNavigator(element) {
    (0, _classCallCheck2["default"])(this, PaymentPageStepNavigator);
    this.element_ = element;
    this.cancelOrderForm_ = document.getElementById("cancelOrderForm");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.doCancelOrder_ = this.doCancelOrder_.bind(this);
    this.initialize_();
  }
  return (0, _createClass2["default"])(PaymentPageStepNavigator, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      if (this.cancelOrderForm_) {
        this.element_.addEventListener("click", function (event) {
          event.preventDefault();
          _this.doCancelOrder_();
        });
      }
    }
  }, {
    key: "doCancelOrder_",
    value: function doCancelOrder_() {
      var url = this.element_.href;
      var nextUrlInput = this.cancelOrderForm_.querySelector("[name=\"next\"]");
      if (url && nextUrlInput) {
        nextUrlInput.value = url;
      }
      this.cancelOrderForm_.submit();
    }
  }]);
}();
var _default = exports["default"] = PaymentPageStepNavigator;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],14:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = paypalCore;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _bootstrapElement = require("./bootstrap-element");
var _apiUtils = _interopRequireDefault(require("../components/api-utils"));
function paypalCore(element) {
  var paypalCreateOrderURL = element.getAttribute("data-create-order-url");
  var paypalTransactioneOrderURL = element.getAttribute("data-transaction-order-url");
  var paypalCcompleteOrderURL = element.getAttribute("data-complete-order-url");
  var paypalToken = element.getAttribute("data-paypal-token");
  var paypalIndicator = element.getAttribute("data-loading-indicator");
  var indicatorContainer = document.createElement("div");
  indicatorContainer.classList.add("d-none");
  indicatorContainer.innerHTML = paypalIndicator;
  element.after(indicatorContainer);
  paypal.Buttons({
    createOrder: function createOrder() {
      return createPayPalOrder(paypalCreateOrderURL, paypalToken);
    },
    style: {
      shape: "pill",
      height: 55
    },
    onCancel: function onCancel() {
      (0, _bootstrapElement.showBootstrapToast)("PayPal transaction cancelled.", "text-bg-info");
    },
    onApprove: function onApprove(data, actions) {
      return handlePayPalApproval(data, actions, paypalToken, paypalTransactioneOrderURL, paypalCcompleteOrderURL, element, indicatorContainer);
    }
  }).render(element);
}
function createPayPalOrder(_x, _x2) {
  return _createPayPalOrder.apply(this, arguments);
}
function _createPayPalOrder() {
  _createPayPalOrder = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(paypalCreateOrderURL, paypalToken) {
    var response, data;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _apiUtils["default"].paypalOrder(paypalCreateOrderURL, {
            token: paypalToken
          });
        case 3:
          response = _context.sent;
          _context.next = 6;
          return response.json();
        case 6:
          data = _context.sent;
          if (!("id" in data)) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return", data.id);
        case 11:
          if (!("detail" in data)) {
            _context.next = 16;
            break;
          }
          (0, _bootstrapElement.showBootstrapToast)("Create PayPal Order Error! Detail: " + data.detail);
          return _context.abrupt("return", null);
        case 16:
          (0, _bootstrapElement.showBootstrapToast)("Create PayPal Order Error! Unknown Error. Please let us know your Order ID when you can report this bug to us.");
          return _context.abrupt("return", null);
        case 18:
          _context.next = 24;
          break;
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](0);
          (0, _bootstrapElement.showBootstrapToast)("Error creating PayPal order: ".concat(_context.t0));
          return _context.abrupt("return", null);
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 20]]);
  }));
  return _createPayPalOrder.apply(this, arguments);
}
function handlePayPalApproval(_x3, _x4, _x5, _x6, _x7, _x8, _x9) {
  return _handlePayPalApproval.apply(this, arguments);
}
function _handlePayPalApproval() {
  _handlePayPalApproval = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(data, actions, paypalToken, paypalTransactioneOrderURL, paypalCcompleteOrderURL, element, indicatorContainer) {
    var authorization, authorizationID, postData, response, responseData;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          /* Show processing and hide PayPal UI */
          indicatorComponent(indicatorContainer, true);
          element.classList.add("d-none");
          _context2.next = 5;
          return actions.order.authorize();
        case 5:
          authorization = _context2.sent;
          authorizationID = authorization.purchase_units[0].payments.authorizations[0].id;
          postData = {
            token: paypalToken,
            authorization_id: authorizationID
          };
          _context2.next = 10;
          return _apiUtils["default"].paypalOrder(paypalTransactioneOrderURL, postData);
        case 10:
          response = _context2.sent;
          if (!response.ok) {
            _context2.next = 15;
            break;
          }
          /* Success, reload to the order detail page */
          window.location.href = paypalCcompleteOrderURL;
          _context2.next = 22;
          break;
        case 15:
          _context2.next = 17;
          return response.json();
        case 17:
          responseData = _context2.sent;
          indicatorComponent(indicatorContainer, false);
          element.classList.remove("d-none");
          document.querySelector("#paypal-button-container").style.display = "block";
          if ("detail" in responseData) {
            (0, _bootstrapElement.showBootstrapToast)("Create PayPal Order Error! Detail: " + responseData.detail, "danger");
          } else {
            (0, _bootstrapElement.showBootstrapToast)("Create PayPal Order Error! Unknown Error. Please let us know your Order ID when you can report this bug to us.");
          }
        case 22:
          _context2.next = 30;
          break;
        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](0);
          /* Recover PayPal UI */
          indicatorComponent(indicatorContainer, false);
          element.classList.remove("d-none");
          (0, _bootstrapElement.showBootstrapToast)("PayPal Transaction Error:" + _context2.t0);
          console.error("PayPal Transaction Error:", _context2.t0);
        case 30:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 24]]);
  }));
  return _handlePayPalApproval.apply(this, arguments);
}
function indicatorComponent(indicatorContainer) {
  var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (show) {
    indicatorContainer.classList.remove("d-none");
  } else {
    indicatorContainer.classList.add("d-none");
  }
}

},{"../components/api-utils":1,"./bootstrap-element":2,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],15:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("./api-utils"));
var _utils = require("../shared/utils");
var _bootstrapElement = require("./bootstrap-element");
/**
 * The component"s block class.
 */

var CLASSES = {
  btnDefault: "bg-brand-light",
  btnDanger: "btn-danger",
  btnSuccess: "btn-success",
  isAdded: "fa",
  exclamationIcon: "fa-exclamation",
  defaultCartIcon: "fa-shopping-cart",
  addedCartIcon: "fa-shopping-basket"
};

/**
 * The component"s selectors.
 */
var SELECTORS = {
  itemId: "itemId",
  hintData: "data-hint",
  disabled: "disabled"
};
var ProductCartManager = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function ProductCartManager(element) {
    (0, _classCallCheck2["default"])(this, ProductCartManager);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * The component"s wrapper.
      */
    this.icon_ = this.element_.querySelector("i");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.handleAddToCartApiCall_ = this.handleAddToCartApiCall_.bind(this);
    this.cartIconRender_ = this.cartIconRender_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(ProductCartManager, [{
    key: "initialize_",
    value: function initialize_() {
      this.element_.addEventListener("click", this.handleAddToCartApiCall_);
    }

    /**
    * Gathers params and call api
    * @private
    */
  }, {
    key: "handleAddToCartApiCall_",
    value: (function () {
      var _handleAddToCartApiCall_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var link, data, response, result, _result, _error$detail;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              link = event.currentTarget;
              if (!link.getAttribute(SELECTORS.disabled)) {
                _context.next = 4;
                break;
              }
              (0, _bootstrapElement.showBootstrapToast)("This product is out of stock", "text-bg-warning");
              return _context.abrupt("return");
            case 4:
              event.preventDefault();
              data = {
                quantity: 1
              };
              data.item_id = link.dataset[SELECTORS.itemId];
              _context.prev = 7;
              _context.next = 10;
              return _apiUtils["default"].addProduct(data);
            case 10:
              response = _context.sent;
              _context.next = 13;
              return response.json();
            case 13:
              result = _context.sent;
              result = (0, _utils.camelCaseAll)(result);
              if (!response.ok) {
                _context.next = 19;
                break;
              }
              this.cartIconRender_((_result = result) === null || _result === void 0 || (_result = _result.addToCart) === null || _result === void 0 ? void 0 : _result.status);
              _context.next = 20;
              break;
            case 19:
              throw result;
            case 20:
              _context.next = 26;
              break;
            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](7);
              (0, _bootstrapElement.showBootstrapToast)((_error$detail = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.detail) !== null && _error$detail !== void 0 ? _error$detail : _context.t0);
              console.warn(_context.t0);
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 22]]);
      }));
      function handleAddToCartApiCall_(_x) {
        return _handleAddToCartApiCall_.apply(this, arguments);
      }
      return handleAddToCartApiCall_;
    }()
    /**
     * Shows heart icon and changes attrubute
     * @param {string} productStatus result.addToCart.status for render
     */
    )
  }, {
    key: "cartIconRender_",
    value: function cartIconRender_(productStatus) {
      if (productStatus === "out_of_stock") {
        this.element_.classList.remove(CLASSES.btnDefault);
        this.element_.classList.add(CLASSES.btnDanger);
        this.element_.setAttribute(SELECTORS.hintData, "Out of Stock");
        this.icon_.classList.remove(CLASSES.defaultCartIcon);
        this.icon_.classList.add(CLASSES.exclamationIcon);
        this.element_.setAttribute("disabled", true);
      } else if (productStatus === "special_order") {
        this.element_.classList.remove(CLASSES.btnDefault);
        this.element_.setAttribute(SELECTORS.hintData, "Special Order");
        this.element_.classList.add(CLASSES.btnSuccess);
        this.icon_.classList.remove(CLASSES.defaultCartIcon);
        this.icon_.classList.add(CLASSES.addedCartIcon);
        (0, _bootstrapElement.showCartOffcanvas)();
      } else {
        this.element_.classList.remove(CLASSES.btnDefault);
        this.element_.classList.add(CLASSES.btnSuccess);
        this.icon_.classList.remove(CLASSES.defaultCartIcon);
        this.icon_.classList.add(CLASSES.addedCartIcon);
        (0, _bootstrapElement.showCartOffcanvas)();
      }
    }
  }]);
}();
var _default = exports["default"] = ProductCartManager;

},{"../shared/utils":27,"./api-utils":1,"./bootstrap-element":2,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],16:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("./api-utils"));
var _bootstrapElement = require("./bootstrap-element");
var _utils = require("../shared/utils");
/**
 * The component's block class.
 */

var CLASSES = {
  isFavorite: "fa",
  notFavorite: "far"
};

/**
 * The component's selectors.
 */
var SELECTORS = {
  itemMatrixId: "itemMatrixId",
  itemId: "itemId",
  favAction: "actionFavorite",
  favActionData: "data-action-favorite",
  hintData: "data-hint"
};
var ProductFavroiteManager = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function ProductFavroiteManager(element) {
    (0, _classCallCheck2["default"])(this, ProductFavroiteManager);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Global variables
      */

    /**
      * The component's wrapper.
      */
    this.icon_ = this.element_.querySelector("i");

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.handleFavoriteApiCall_ = this.handleFavoriteApiCall_.bind(this);
    this.favoriteThumbRender_ = this.favoriteThumbRender_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(ProductFavroiteManager, [{
    key: "initialize_",
    value: function initialize_() {
      this.element_.addEventListener("click", this.handleFavoriteApiCall_);
    }

    /**
    * Gathers params and call api
    * @private
    */
  }, {
    key: "handleFavoriteApiCall_",
    value: (function () {
      var _handleFavoriteApiCall_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var link, data, response, result, updateEvent, _updateEvent, _error$detail;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              link = event.currentTarget;
              data = {};
              if (link.dataset[SELECTORS.itemMatrixId] == 0) {
                data.item_id = link.dataset[SELECTORS.itemId];
              } else {
                data.item_matrix_id = link.dataset[SELECTORS.itemMatrixId];
              }
              if (link.dataset[SELECTORS.favAction] === "remove") {
                data["delete"] = true;
              }
              _context.prev = 5;
              _context.next = 8;
              return _apiUtils["default"].favoriteProduct(data);
            case 8:
              response = _context.sent;
              _context.next = 11;
              return response.json();
            case 11:
              result = _context.sent;
              if (!response.ok) {
                _context.next = 16;
                break;
              }
              if (result.result === null) {
                data.action = "complete_favorite";
                data.next = location.pathname;
                window.location = "/accounts/login/?".concat(new URLSearchParams(data).toString());
              } else if (result.result) {
                /* added to favs */
                this.favoriteThumbRender_(true);
                /* updats the global favorite count, TODO: pending backend api */
                updateEvent = new CustomEvent("updateInnerText", {
                  detail: {
                    innerText: "?"
                  }
                });
                (0, _utils.updateAllWishlistCountNumber)(updateEvent);
              } else {
                /* removed from favorite */
                this.favoriteThumbRender_(false);
                /* updats the global favorite count, TODO: pending backend api */
                _updateEvent = new CustomEvent("updateInnerText", {
                  detail: {
                    innerText: "?"
                  }
                });
                (0, _utils.updateAllWishlistCountNumber)(_updateEvent);
              }
              _context.next = 17;
              break;
            case 16:
              throw result;
            case 17:
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](5);
              (0, _bootstrapElement.showBootstrapToast)((_error$detail = _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.detail) !== null && _error$detail !== void 0 ? _error$detail : _context.t0);
              console.warn(_context.t0);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 19]]);
      }));
      function handleFavoriteApiCall_(_x) {
        return _handleFavoriteApiCall_.apply(this, arguments);
      }
      return handleFavoriteApiCall_;
    }()
    /**
     * Shows heart icon and changes attrubute
     * @param {boolean} isFav the rendering result
     */
    )
  }, {
    key: "favoriteThumbRender_",
    value: function favoriteThumbRender_(isFav) {
      if (isFav) {
        this.icon_.classList.remove(CLASSES.notFavorite);
        this.icon_.classList.add(CLASSES.isFavorite);
        this.element_.setAttribute(SELECTORS.favActionData, "remove");
        this.element_.setAttribute(SELECTORS.hintData, "Remove from favorite");
      } else {
        this.icon_.classList.add(CLASSES.notFavorite);
        this.icon_.classList.remove(CLASSES.isFavorite);
        this.element_.setAttribute(SELECTORS.favActionData, "add");
        this.element_.setAttribute(SELECTORS.hintData, "Add to favorite");
      }
    }
  }]);
}();
var _default = exports["default"] = ProductFavroiteManager;

},{"../shared/utils":27,"./api-utils":1,"./bootstrap-element":2,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],17:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */

/**
 * The component's selectors.
 */
var SELECTORS = {
  sortAction: "[data-sort-action]",
  filterInput: "[data-filter-input]",
  filterLabel: "[data-filter-label]",
  modalFilterToggle: "data-toggle-filter",
  modalFilterCurrentState: "data-current-state",
  selectedBtns: "data-selected-filter",
  containerRemoveBtn: "[data-container-remove-buttons]",
  cleanAction: "[data-action-clean]"
};
var ProductListFilterSortForm = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function ProductListFilterSortForm(element) {
    (0, _classCallCheck2["default"])(this, ProductListFilterSortForm);
    /**
     * Component main element.
     * @type {!Element}
    */
    this.element_ = element;

    /**
     * The component's wrapper.
    */
    this.sortEls_ = this.element_.querySelectorAll(SELECTORS.sortAction);
    this.filterLableEls_ = this.element_.querySelectorAll(SELECTORS.filterLabel);
    this.filterInputEls_ = this.element_.querySelectorAll(SELECTORS.filterInput);
    this.filterTogglerEls_ = this.element_.querySelectorAll("[".concat(SELECTORS.modalFilterToggle, "]"));
    this.selectedBtnEls_ = this.element_.querySelectorAll("[".concat(SELECTORS.selectedBtns, "]"));
    this.cleanEls_ = this.element_.querySelectorAll(SELECTORS.cleanAction);
    this.bottomSelectedFilterContainer_ = this.element_.querySelector(SELECTORS.containerRemoveBtn);

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.sortAction_ = this.sortAction_.bind(this);
    this.filterAction_ = this.filterAction_.bind(this);
    this.cleanAction_ = this.cleanAction_.bind(this);
    this.modalFilterToggleAction_ = this.modalFilterToggleAction_.bind(this);
    this.modalSelectedFilterAction_ = this.modalSelectedFilterAction_.bind(this);
    this.inputToggle_ = this.inputToggle_.bind(this);
    this.updateToggerStyle_ = this.updateToggerStyle_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(ProductListFilterSortForm, [{
    key: "initialize_",
    value: function initialize_() {
      this.sortAction_();
      this.filterAction_();
      this.modalFilterToggleAction_();
      this.modalSelectedFilterAction_();
      this.cleanAction_();
    }

    /**
     * sort product list
     * @private
     */
  }, {
    key: "sortAction_",
    value: function sortAction_() {
      var _this = this;
      this.sortEls_.forEach(function (item) {
        item.addEventListener("change", function () {
          _this.element_.submit();
        });
      });
    }

    /**
     * Filters product list
     * @private
     */
  }, {
    key: "filterAction_",
    value: function filterAction_() {
      var _this2 = this;
      this.filterLableEls_.forEach(function (item) {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          var checkboxId = item.getAttribute("for");
          _this2.inputToggle_(checkboxId);
          _this2.element_.submit();
        });
      });
    }

    /**
     * Modal filter top button
     * @private
     */
  }, {
    key: "modalFilterToggleAction_",
    value: function modalFilterToggleAction_() {
      var _this3 = this;
      this.filterTogglerEls_.forEach(function (item) {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          var checkboxId = item.getAttribute(SELECTORS.modalFilterToggle);
          var currentStatus = item.getAttribute(SELECTORS.modalFilterCurrentState);
          var nextState = currentStatus === "true" ? false : true;

          /* update input value */
          _this3.inputToggle_(checkboxId);
          /* update toggler style */
          _this3.updateToggerStyle_(nextState, item);
          /* update button */
          if (nextState) {
            /* add bottom selected button */
            var button = document.createElement("button");
            button.type = "button";
            button.dataset.selectedFilter = checkboxId;
            button.classList.add("align-items-center", "btn", "btn-sm", "fw-normal", "btn-secondary", "d-inline-flex", "me-3", "px-3", "py-1", "rounded-4", "text-capitalize", "text-decoration-none", "text-start");
            button.innerHTML = "".concat(item.textContent, "<i class=\"ms-2 fal fa-times\"></i>");
            /* add event on the button */
            button.addEventListener("click", function () {
              /* find the input and sets value */
              _this3.inputToggle_(checkboxId);
              /* toggle element update */
              var toggleFilterElement = _this3.element_.querySelector("[".concat(SELECTORS.modalFilterToggle, "=\"").concat(checkboxId, "\"]"));
              _this3.updateToggerStyle_(false, toggleFilterElement);
              /* removes itself */
              button.remove();
            });
            _this3.bottomSelectedFilterContainer_.appendChild(button);
          } else {
            /* remove bottom selected button */
            var buttonsToRemove = _this3.bottomSelectedFilterContainer_.querySelectorAll("[data-selected-filter=\"".concat(checkboxId, "\"]"));
            buttonsToRemove.forEach(function (button) {
              button.remove();
            });
          }
        });
      });
    }

    /**
     * Modal remove filter button
     * @private
     */
  }, {
    key: "modalSelectedFilterAction_",
    value: function modalSelectedFilterAction_() {
      var _this4 = this;
      this.selectedBtnEls_.forEach(function (item) {
        item.addEventListener("click", function () {
          var checkboxId = item.getAttribute(SELECTORS.selectedBtns);
          /* find the input and sets value */
          _this4.inputToggle_(checkboxId);
          /* toggle element update */
          var toggleFilterElement = _this4.element_.querySelector("[".concat(SELECTORS.modalFilterToggle, "=\"").concat(checkboxId, "\"]"));
          _this4.updateToggerStyle_(false, toggleFilterElement);
          /* removes itself */
          item.remove();
        });
      });
    }

    /**
     * Finds the input lable with checkbox id, and do the toggle
     * @param {string} checkboxId string base on current element
     */
  }, {
    key: "inputToggle_",
    value: function inputToggle_(checkboxId) {
      var checkbox = this.element_.querySelector("#".concat(checkboxId));
      /* Toggle the checkbox's checked state */
      checkbox.checked = !checkbox.checked;
    }

    /**
     * update toggler style, and attribute
     * @param {boolean} nextState the next state
     * @param {element} togglerElement html dom element
     */
  }, {
    key: "updateToggerStyle_",
    value: function updateToggerStyle_(nextState, togglerElement) {
      togglerElement.setAttribute(SELECTORS.modalFilterCurrentState, nextState);
      togglerElement.classList.toggle("link-offset-2", nextState);
      togglerElement.classList.toggle("link-underline-opacity-100", nextState);
      togglerElement.classList.toggle("fw-bold", nextState);
    }

    /**
     * Filters product list
     * @private
     */
  }, {
    key: "cleanAction_",
    value: function cleanAction_() {
      var _this5 = this;
      (0, _toConsumableArray2["default"])(this.cleanEls_).map(function (item) {
        item.addEventListener("click", function (event) {
          event.preventDefault();
          (0, _toConsumableArray2["default"])(_this5.filterInputEls_).map(function (inputItem) {
            return inputItem.checked = false;
          });
          _this5.element_.submit();
        });
      });
    }
  }]);
}();
var _default = exports["default"] = ProductListFilterSortForm;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/helpers/toConsumableArray":38}],18:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _apiUtils = _interopRequireDefault(require("./api-utils"));
var _productFavoriteManager = _interopRequireDefault(require("./product-favorite-manager"));
var _productCartManager = _interopRequireDefault(require("./product-cart-manager"));
var _rightClickDisable = _interopRequireDefault(require("./right-click-disable"));
/**
 * The component"s block class.
 */

/**
 * The component"s selectors.
 */
var SELECTORS = {
  loading: "[data-loading]"
};
var ProductList = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function ProductList(element) {
    (0, _classCallCheck2["default"])(this, ProductList);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;
    this.loadingEl_ = this.element_.querySelector(SELECTORS.loading);
    this.categoryApi_ = this.element_.dataset.categoryApi;

    // Initialize as not loaded , for re-scroll after product loaded
    this.loaded_ = false;
    this.hash_ = null;
    this.scrollTriggered_ = false;

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.getProductList_ = this.getProductList_.bind(this);
    this.scrollToHashAfterInitialize_ = this.scrollToHashAfterInitialize_.bind(this);
    this.renderProductThumb_ = this.renderProductThumb_.bind(this);
    this.renderAutoReplenish_ = this.renderAutoReplenish_.bind(this);
    this.noProducts_ = this.noProducts_.bind(this);
    this.renderLoadMoreButton_ = this.renderLoadMoreButton_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(ProductList, [{
    key: "initialize_",
    value: (function () {
      var _initialize_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              /* remove the default scroll, wait till product loaded */
              this.hash_ = window.location.hash;
              window.history.replaceState(null, null, " "); // Clear hash from URL
              _context.next = 4;
              return this.getProductList_();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initialize_() {
        return _initialize_.apply(this, arguments);
      }
      return initialize_;
    }()
    /**
     * Gets product list
     * @private
     */
    )
  }, {
    key: "getProductList_",
    value: (function () {
      var _getProductList_ = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var _this = this;
        var response, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _apiUtils["default"].getProductList(this.categoryApi_);
            case 3:
              response = _context2.sent;
              _context2.next = 6;
              return response.json();
            case 6:
              result = _context2.sent;
              if (response.ok) {
                if (result.results.length > 0) {
                  result.results.forEach(function (productItem) {
                    if (productItem.type === "ProductAdBanner") {
                      _this.renderAutoReplenish_(productItem);
                    } else {
                      _this.renderProductThumb_(productItem);
                    }
                  });
                  if (result.next) {
                    this.renderLoadMoreButton_();
                    this.categoryApi_ = result.next;
                  }
                } else {
                  this.noProducts_();
                }
              }
              _context2.next = 13;
              break;
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.warn(_context2.t0);
            case 13:
              _context2.prev = 13;
              this.loaded_ = true;
              this.scrollToHashAfterInitialize_();
              this.loadingEl_.remove();
              return _context2.finish(13);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 10, 13, 18]]);
      }));
      function getProductList_() {
        return _getProductList_.apply(this, arguments);
      }
      return getProductList_;
    }()
    /**
     * Scroll to hashtag location (anchor) after first time product load.
     * NOTE: Hotfix function, using setTimeout to wait for product loaded.
     * @private
     */
    )
  }, {
    key: "scrollToHashAfterInitialize_",
    value: function scrollToHashAfterInitialize_() {
      var _this2 = this;
      if (this.hash_ && !this.scrollTriggered_) {
        if (this.loaded_) {
          setTimeout(function () {
            var _document$querySelect;
            (_document$querySelect = document.querySelector(_this2.hash_)) === null || _document$querySelect === void 0 || _document$querySelect.scrollIntoView({
              behavior: "smooth"
            });
          }, 1000); // Adjust timing as needed
          this.scrollTriggered_ = true;
        }
      }
    }

    /**
     * renders empty content
     * @private
     */
  }, {
    key: "noProducts_",
    value: function noProducts_() {
      var textDiv = document.createElement("div");
      textDiv.classList.add("w-100", "text-center");
      textDiv.textContent = "Sorry, no product was found.";
      this.element_.prepend(textDiv);
    }

    /**
     * renders Auto-Replenish
     * @private
     */
  }, {
    key: "renderAutoReplenish_",
    value: function renderAutoReplenish_(bannerItem) {
      var outerDiv = document.createElement("div");
      outerDiv.classList.add("col");
      outerDiv.setAttribute("data-action-layout", "item");
      outerDiv.setAttribute("data-advertisement", "");

      // Create the anchor element
      var anchorElement = document.createElement("a");
      anchorElement.classList.add("mb-3");
      anchorElement.href = bannerItem.url;
      anchorElement.title = bannerItem.name;

      /* Create the image element */
      var imgElement = document.createElement("img");
      imgElement.src = bannerItem.image_url;
      imgElement.classList.add("img-fluid", "object-fit-contain");
      imgElement.loading = "lazy";
      (0, _rightClickDisable["default"])(imgElement);

      /* Append the image element to the anchor element */
      anchorElement.appendChild(imgElement);

      /* Append the anchor element to the outer div */
      outerDiv.appendChild(anchorElement);
      this.element_.append(outerDiv);
    }

    /**
     * renders product item
     * @param {object} productItem
     */
  }, {
    key: "renderProductThumb_",
    value: function renderProductThumb_(productItem) {
      var colDiv = document.createElement("div");
      colDiv.classList.add("col");
      colDiv.setAttribute("data-action-layout", "item");
      var productDiv = document.createElement("div");
      productDiv.classList.add("product");
      var productThumbDiv = document.createElement("div");
      productThumbDiv.classList.add("mx-auto", "product-thumb");
      productThumbDiv.style.maxWidth = "none";

      /* badges */
      var productBadgesSpan = document.createElement("span");
      productBadgesSpan.classList.add("product-badges", "bottom-0", "flex-wrap");

      // if (productItem.is_label_sale) {
      //   const saleBadgeSpan = document.createElement("span");
      //   const saleBadgeImg = document.createElement("img");
      //   saleBadgeImg.classList.add("img-fluid");
      //   saleBadgeImg.src = "/static/images/product-labels/icon-sale.webp";
      //   saleBadgeImg.alt = "sale";
      //   saleBadgeSpan.appendChild(saleBadgeImg);
      //   productBadgesSpan.appendChild(saleBadgeSpan);
      // }
      if (productItem.discount) {
        if (productItem.discount.amount) {
          var onSaleSpan = document.createElement("span");
          onSaleSpan.classList.add("onsale");
          onSaleSpan.textContent = "-$".concat(productItem.discount.amount); // TODO: Replace with backend dynamic value
          productBadgesSpan.appendChild(onSaleSpan);
        } else if (productItem.discount.percent) {
          var _onSaleSpan = document.createElement("span");
          _onSaleSpan.classList.add("onsale");
          _onSaleSpan.textContent = "-".concat(productItem.discount.percent * 100, "%");
          productBadgesSpan.appendChild(_onSaleSpan);
        }
      }
      if (productItem.is_label_new) {
        var newTagSpan = document.createElement("span");
        newTagSpan.classList.add("bg-warning");
        newTagSpan.textContent = "new";
        productBadgesSpan.appendChild(newTagSpan);
      }
      if (productItem.is_label_popular) {
        var hotTagSpan = document.createElement("span");
        hotTagSpan.classList.add("hot");
        hotTagSpan.textContent = "hot";
        productBadgesSpan.appendChild(hotTagSpan);
      }
      if (productItem.is_label_pre_order_now) {
        var preOrderNowBadgeSpan = document.createElement("span");
        var preOrderNowBadgeImg = document.createElement("img");
        preOrderNowBadgeImg.classList.add("img-fluid");
        preOrderNowBadgeImg.src = "/static/images/product-labels/icon-pre-order-now.webp";
        preOrderNowBadgeImg.alt = "Pre-Order Now";
        preOrderNowBadgeSpan.appendChild(preOrderNowBadgeImg);
        productBadgesSpan.appendChild(preOrderNowBadgeSpan);
      }
      if (productItem.is_label_clearance) {
        var clearanceBadgeSpan = document.createElement("span");
        var clearanceBadgeImg = document.createElement("img");
        clearanceBadgeImg.classList.add("img-fluid");
        clearanceBadgeImg.src = "/static/images/product-labels/icon-clearance.webp";
        clearanceBadgeImg.alt = "clearance";
        clearanceBadgeSpan.appendChild(clearanceBadgeImg);
        productBadgesSpan.appendChild(clearanceBadgeSpan);
      }
      productThumbDiv.appendChild(productBadgesSpan);
      var positionSpan = document.createElement("span");
      positionSpan.classList.add("position-absolute", "start-0", "w-100", "z-3", "bottom-0");
      var buyOneGetOneImg = document.createElement("img");
      buyOneGetOneImg.classList.add("w-100", "img-fluid");
      if (productItem.is_label_buy_five_get_one_free) {
        buyOneGetOneImg.src = "/static/images/product-labels/icon-five-one.webp";
        buyOneGetOneImg.alt = "buy five get one free";
      } else if (productItem.is_label_buy_six_get_one_free) {
        buyOneGetOneImg.src = "/static/images/product-labels/icon-six-one.webp";
        buyOneGetOneImg.alt = "buy six get one free";
      } else if (productItem.is_label_buy_eight_get_one_free) {
        buyOneGetOneImg.src = "/static/images/product-labels/icon-eight-one.webp";
        buyOneGetOneImg.alt = "buy eight get one free";
      } else if (productItem.is_label_buy_ten_get_one_free) {
        buyOneGetOneImg.src = "/static/images/product-labels/icon-ten-one.webp";
        buyOneGetOneImg.alt = "buy ten get one free";
      } else if (productItem.is_label_buy_twelve_get_one_free) {
        buyOneGetOneImg.src = "/static/images/product-labels/icon-twelve-one.webp";
        buyOneGetOneImg.alt = "buy twelve get one free";
      }
      positionSpan.appendChild(buyOneGetOneImg);
      productThumbDiv.appendChild(positionSpan);
      var productImageAnchor = document.createElement("a");
      productImageAnchor.classList.add("image");
      productImageAnchor.href = productItem.url;
      productImageAnchor.title = productItem.description;
      if (productItem.thumbnails) {
        var productImage = document.createElement("img");
        productImage.src = productItem.thumbnails[0];
        productImage.alt = productItem.description;
        productImage.loading = "lazy";
        (0, _rightClickDisable["default"])(productImage);
        productImageAnchor.appendChild(productImage);
      } else {
        var _productImage = document.createElement("img");
        _productImage.src = "/static/images/logo/logo_text_square.webp";
        _productImage.alt = productItem.description;
        productImageAnchor.appendChild(_productImage);
        _productImage.loading = "lazy";
        (0, _rightClickDisable["default"])(_productImage);
      }
      if (productItem.thumbnails[1]) {
        var hoverImage = document.createElement("img");
        hoverImage.classList.add("image-hover");
        hoverImage.src = productItem.thumbnails[1];
        hoverImage.alt = productItem.description;
        (0, _rightClickDisable["default"])(hoverImage);
        productImageAnchor.appendChild(hoverImage);
      }
      productThumbDiv.appendChild(productImageAnchor);
      var wishlistAnchor = document.createElement("a");
      wishlistAnchor.classList.add("add-to-wishlist", "hintT-left");
      wishlistAnchor.setAttribute("data-hint", productItem.is_favorite ? "Remove form wishlist" : "Add to wishlist");
      wishlistAnchor.setAttribute("data-action-favorite", productItem.is_favorite ? "remove" : "add");
      wishlistAnchor.setAttribute("data-item-matrix-id", productItem.item_matrix_id);
      wishlistAnchor.setAttribute("data-item-id", productItem.item_id);
      var wishlistIcon = document.createElement("i");
      if (productItem.is_favorite) {
        wishlistIcon.classList.add("fa", "fa-heart");
      } else {
        wishlistIcon.classList.add("far", "fa-heart");
      }
      wishlistAnchor.appendChild(wishlistIcon);
      new _productFavoriteManager["default"](wishlistAnchor);
      productThumbDiv.appendChild(wishlistAnchor);
      var productOptionsDiv = document.createElement("div");
      productOptionsDiv.classList.add("product-options");

      // colors
      if (productItem.is_item_matrix && productItem.attribute_meta.color_groups.length > 0) {
        var colorGroups = productItem.attribute_meta.color_groups;
        var colorsUl = document.createElement("ul");
        colorsUl.classList.add("colors");
        colorGroups.forEach(function (cg) {
          var colorLi = document.createElement("li");
          if (cg.color_code != "multi") {
            colorLi.style.backgroundColor = cg.color_code;
          } else {
            colorLi.style.backgroundSize = "cover";
            colorLi.classList.add("widget-colors--color-tag");
            colorLi.classList.add("widget-colors--color-multi");
          }
          colorLi.textContent = cg.name;
          colorsUl.appendChild(colorLi);
        });
        productOptionsDiv.appendChild(colorsUl);
      }

      // sizes
      if (productItem.is_item_matrix && productItem.attribute_meta.sizes.length > 0) {
        var sizes = productItem.attribute_meta.sizes;
        var sizesUl = document.createElement("ul");
        sizesUl.classList.add("sizes");
        for (var i = 0; i < sizes.length; i++) {
          var size = sizes[i];
          var sizeLi = document.createElement("li");
          sizeLi.textContent = size.name;
          sizesUl.appendChild(sizeLi);
        }
        productOptionsDiv.appendChild(sizesUl);
      }
      if (productItem.is_item_matrix && (productItem.attribute_meta.color_groups.length || productItem.attribute_meta.sizes.length)) {
        productThumbDiv.appendChild(productOptionsDiv);
      }
      productDiv.appendChild(productThumbDiv);
      var productInfoDiv = document.createElement("div");
      productInfoDiv.classList.add("product-info");
      var titleH6 = document.createElement("h6");
      titleH6.classList.add("title");
      var titleAnchor = document.createElement("a");
      titleAnchor.href = productItem.url;
      titleAnchor.title = productItem.description;
      titleAnchor.textContent = productItem.description;
      titleH6.appendChild(titleAnchor);
      productInfoDiv.appendChild(titleH6);
      var priceSpan = document.createElement("span");
      priceSpan.classList.add("price");
      if (productItem.discount) {
        var newPriceSpan = document.createElement("span");
        newPriceSpan.classList.add("new");
        newPriceSpan.textContent = "$" + productItem.discounted_default_price.amount + " CAD";
        priceSpan.appendChild(newPriceSpan);
        var oldPriceSpan = document.createElement("span");
        oldPriceSpan.classList.add("old");
        oldPriceSpan.textContent = "$" + productItem.default_price.amount;
        priceSpan.appendChild(oldPriceSpan);
      } else {
        priceSpan.textContent = "$ " + productItem.default_price.amount + " CAD";
      }
      productInfoDiv.appendChild(priceSpan);
      var productButtonsDiv = document.createElement("div");
      productButtonsDiv.classList.add("product-buttons");
      var quickViewAnchor = document.createElement("a");
      quickViewAnchor.href = "#quickViewModal";
      quickViewAnchor.setAttribute("data-bs-toggle", "modal");
      quickViewAnchor.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center");
      quickViewAnchor.setAttribute("data-hint", "Quick View");
      if (productItem.detail_api_url) {
        quickViewAnchor.setAttribute("data-product-api", productItem.detail_api_url);
      }
      var quickViewIcon = document.createElement("i");
      quickViewIcon.classList.add("fas", "fa-search");
      quickViewAnchor.appendChild(quickViewIcon);
      productButtonsDiv.appendChild(quickViewAnchor);
      if (productItem.is_item_matrix) {
        if (productItem.qoh > 0) {
          var addToCartAnchor = document.createElement("a");
          addToCartAnchor.href = productItem.url;
          addToCartAnchor.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "bg-brand-light");
          addToCartAnchor.setAttribute("data-hint", "More Options");
          var shoppingCartIcon = document.createElement("i");
          shoppingCartIcon.classList.add("far", "fa-plus-square");
          addToCartAnchor.appendChild(shoppingCartIcon);
          productButtonsDiv.appendChild(addToCartAnchor);
        } else if (productItem.special_order === "ten_days" || productItem.special_order === "two_weeks" || productItem.special_order === "four_weeks") {
          var _addToCartAnchor = document.createElement("a");
          _addToCartAnchor.href = productItem.url;
          _addToCartAnchor.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "bg-brand-orange");
          _addToCartAnchor.setAttribute("data-hint", "Special Order");
          var _shoppingCartIcon = document.createElement("i");
          _shoppingCartIcon.classList.add("fas", "fa-hourglass-start");
          _addToCartAnchor.appendChild(_shoppingCartIcon);
          productButtonsDiv.appendChild(_addToCartAnchor);
        } else {
          var _addToCartAnchor2 = document.createElement("a");
          _addToCartAnchor2.href = productItem.url;
          _addToCartAnchor2.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "btn-danger");
          _addToCartAnchor2.setAttribute("data-hint", "Out Of Stock");
          var exclamationCircleIcon = document.createElement("i");
          exclamationCircleIcon.classList.add("fas", "fa-exclamation");
          _addToCartAnchor2.appendChild(exclamationCircleIcon);
          productButtonsDiv.appendChild(_addToCartAnchor2);
        }
      } else {
        if (productItem.qoh > 0) {
          var _addToCartAnchor3 = document.createElement("a");
          _addToCartAnchor3.href = productItem.url;
          _addToCartAnchor3.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "bg-success");
          _addToCartAnchor3.setAttribute("data-hint", "Add to Cart");
          _addToCartAnchor3.setAttribute("data-item-id", productItem.item_id);
          _addToCartAnchor3.setAttribute("data-action-cart", "add");
          var _shoppingCartIcon2 = document.createElement("i");
          _shoppingCartIcon2.classList.add("fas", "fa-shopping-cart");
          _addToCartAnchor3.appendChild(_shoppingCartIcon2);
          new _productCartManager["default"](_addToCartAnchor3);
          productButtonsDiv.appendChild(_addToCartAnchor3);
        } else if (productItem.special_order === "ten_days" || productItem.special_order === "two_weeks" || productItem.special_order === "four_weeks") {
          var _addToCartAnchor4 = document.createElement("a");
          _addToCartAnchor4.href = productItem.url;
          _addToCartAnchor4.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "bg-brand-orange");
          _addToCartAnchor4.setAttribute("data-hint", "Special Order");
          _addToCartAnchor4.setAttribute("data-item-id", productItem.item_id);
          _addToCartAnchor4.setAttribute("data-action-cart", "add");
          var _shoppingCartIcon3 = document.createElement("i");
          _shoppingCartIcon3.classList.add("fas", "fa-hourglass-start");
          _addToCartAnchor4.appendChild(_shoppingCartIcon3);
          new _productCartManager["default"](_addToCartAnchor4);
          productButtonsDiv.appendChild(_addToCartAnchor4);
        } else {
          var _addToCartAnchor5 = document.createElement("a");
          _addToCartAnchor5.href = productItem.url;
          _addToCartAnchor5.classList.add("product-button", "hintT-top", "align-items-center", "d-flex", "justify-content-center", "btn-danger");
          _addToCartAnchor5.setAttribute("data-hint", "Out of Stock");
          var _exclamationCircleIcon = document.createElement("i");
          _exclamationCircleIcon.classList.add("fas", "fa-exclamation");
          _addToCartAnchor5.appendChild(_exclamationCircleIcon);
          productButtonsDiv.appendChild(_addToCartAnchor5);
        }
      }
      productInfoDiv.appendChild(productButtonsDiv);
      productDiv.appendChild(productInfoDiv);
      colDiv.appendChild(productDiv);
      this.element_.appendChild(colDiv);
    }

    /**
     * load more button
     * @private
     */
  }, {
    key: "renderLoadMoreButton_",
    value: function renderLoadMoreButton_() {
      var _this3 = this;
      var divEl = document.createElement("div");
      divEl.classList.add("text-center", "learts-mt-70", "mb-5", "w-100");
      var loadMorebutton = document.createElement("button");
      loadMorebutton.setAttribute("type", "button");
      loadMorebutton.classList.add("btn", "btn-dark", "btn-outline-hover-dark");
      var icon = document.createElement("i");
      icon.classList.add("fa-plus", "fal");
      loadMorebutton.appendChild(icon);
      loadMorebutton.appendChild(document.createTextNode("More"));
      divEl.appendChild(loadMorebutton);

      /* Adding an event listener to the button */
      loadMorebutton.addEventListener("click", function () {
        _this3.element_.append(_this3.loadingEl_);
        divEl.remove();
        _this3.getProductList_();
      });
      this.element_.appendChild(divEl);
    }
  }]);
}();
var _default = exports["default"] = ProductList;

},{"./api-utils":1,"./product-cart-manager":15,"./product-favorite-manager":16,"./right-click-disable":20,"@babel/runtime/helpers/asyncToGenerator":30,"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/regenerator":43}],19:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */

/**
 * The component's selectors.
 */
var SELECTORS = {
  container: "[data-action-layout='container']",
  columnData: "data-column"
};
var ProductsLayoutAnimation = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function ProductsLayoutAnimation(element) {
    (0, _classCallCheck2["default"])(this, ProductsLayoutAnimation);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * The component's wrapper.
      */

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.onLayout = this.onLayout.bind(this);
    this.removeClassesStartingWith_ = this.removeClassesStartingWith_.bind(this);
    this.buttonStyle_ = this.buttonStyle_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(ProductsLayoutAnimation, [{
    key: "initialize_",
    value: function initialize_() {
      this.element_.addEventListener("click", this.onLayout);
    }

    /**
     * do animation
     */
  }, {
    key: "onLayout",
    value: function onLayout() {
      var columns = this.element_.getAttribute(SELECTORS.columnData);
      var targetContainer = document.querySelector(SELECTORS.container);
      /* set up row */
      this.removeClassesStartingWith_(targetContainer, "row-cols-xl-");
      targetContainer.classList.add("row-cols-xl-".concat(columns));
      /* style of current button */
      this.buttonStyle_();
    }

    /**
     * remove other layout class
     * @param {element} containerElement
     * @param {string} classNamePrefix
     */
  }, {
    key: "removeClassesStartingWith_",
    value: function removeClassesStartingWith_(containerElement, classNamePrefix) {
      var classes = containerElement.className.split(" ");
      var filteredClasses = classes.filter(function (className) {
        return !className.startsWith(classNamePrefix);
      });
      containerElement.className = filteredClasses.join(" ");
    }

    /**
     * adjust the toggle button styles
     */
  }, {
    key: "buttonStyle_",
    value: function buttonStyle_() {
      var _this = this;
      document.querySelectorAll("[data-action-layout='btn']").forEach(function (element) {
        if (element !== _this.element_) {
          element.classList.remove("active");
        }
      });
      this.element_.classList.add("active");
    }
  }]);
}();
var _default = exports["default"] = ProductsLayoutAnimation;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = function _default(element_) {
  element_.addEventListener("contextmenu", function (e) {
    e.preventDefault();
  });
};

},{}],21:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */
var CLASSES = {
  absolute: "position-absolute",
  stickyHeader: "sticky-header",
  stickyOn: "is-sticky"
};
var StickyHeader = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function StickyHeader(element) {
    (0, _classCallCheck2["default"])(this, StickyHeader);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Global components
      */
    this.menuOuterEles_ = this.element_.querySelectorAll("[data-header='wrapper']");
    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.stickyHeader_ = this.stickyHeader_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(StickyHeader, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      window.addEventListener("scroll", function () {
        _this.menuOuterEles_.forEach(function (menuOuter_) {
          var mainContent = menuOuter_.querySelector("[data-header='menuContent']");
          _this.stickyHeader_(menuOuter_, mainContent);
        });
      });
    }

    /**
     * sticky the header
     */
  }, {
    key: "stickyHeader_",
    value: function stickyHeader_(outerElement, mainElement) {
      var scrollPosition = window.scrollY || document.documentElement.scrollTop;

      /* Get the half bottom position of threshold */
      var thresholdOne = outerElement.offsetTop + outerElement.offsetHeight * 1 / 2;
      var thresholdTwo = outerElement.offsetTop + outerElement.offsetHeight + outerElement.offsetHeight / 2;
      if (scrollPosition >= thresholdOne) {
        /* The half bottom of spacingAnchor has reached the top of the viewport */
        mainElement.classList.remove(CLASSES.absolute);
        mainElement.classList.add(CLASSES.stickyHeader);
        if (scrollPosition > thresholdTwo) {
          /* The 3/2 height of menu has reached the top of the viewport */
          mainElement.classList.add(CLASSES.stickyOn);
        } else {
          mainElement.classList.remove(CLASSES.stickyOn);
        }
      } else {
        mainElement.classList.add(CLASSES.absolute);
        mainElement.classList.remove(CLASSES.stickyHeader);
      }
    }
  }]);
}();
var _default = exports["default"] = StickyHeader;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],22:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component"s block class.
 */
var SELECTORS = {
  TOGGLE_BTN: "[data-click=\"togglePasswordBtn\"]",
  PASSWORD_INPUT: "input[type=\"password\"]"
};
/**
 * The classes" block class
 */
var CLASSES = {
  EYE_SLASH: "fa-eye-slash",
  EYE: "fa-eye"
};
var TogglePassword = exports["default"] = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {!Element} element
   */
  function TogglePassword(element) {
    (0, _classCallCheck2["default"])(this, TogglePassword);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
     * Toggle button element
     * @type {!Element}
     */
    this.toggleBtn_ = this.element_.querySelector(SELECTORS.TOGGLE_BTN);

    /**
     * Password input element
     * @type {!Element}
     */
    this.passwordInput_ = this.element_.querySelector(SELECTORS.PASSWORD_INPUT);

    /**
     * Icon element
     * @type {!Element}
     */
    this.icon_ = this.toggleBtn_.querySelector("i");

    /**
     * Binds functions.
     */
    this.initialize_ = this.initialize_.bind(this);
    this.handleToggleClick_ = this.handleToggleClick_.bind(this);
    this.initialize_();
  }

  /**
   * Initializes the component.
   * @private
   */
  return (0, _createClass2["default"])(TogglePassword, [{
    key: "initialize_",
    value: function initialize_() {
      if (this.toggleBtn_) {
        this.toggleBtn_.addEventListener("click", this.handleToggleClick_);
      }
    }

    /**
     * Handles toggle button click
     * @private
     */
  }, {
    key: "handleToggleClick_",
    value: function handleToggleClick_() {
      var isPasswordVisible = this.passwordInput_.type === "text";
      if (isPasswordVisible) {
        // Hide password
        this.passwordInput_.type = "password";
        this.icon_.classList.remove(CLASSES.EYE_SLASH);
        this.icon_.classList.add(CLASSES.EYE);
      } else {
        // Show password
        this.passwordInput_.type = "text";
        this.icon_.classList.remove(CLASSES.EYE);
        this.icon_.classList.add(CLASSES.EYE_SLASH);
      }
    }
  }]);
}();
/* NOTE: Here is how it works:
---the html structure of the password input with toggle button---
  <div class="input-group" data-click="togglePassword">
    <input  type="password" name="password" placeholder="Password*" class="form-control w-auto textinput textInput">
    <button data-click="togglePasswordBtn" class="input-group-text toggle-password-btn" type="button" >
      <i class="fa fa-eye"></i>
    </button>
  </div>
*/

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],23:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's block class.
 */
var SELECTORS = {
  DROPDOWN_TRIGGER: "[data-bs-toggle='dropdown']",
  DROPDOWN_MENU: "[data-show-focus='searchMenu']",
  INPUT: "input[type='text']"
};
var ToggleSearchFocus = exports["default"] = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {!Element} element
   */
  function ToggleSearchFocus(element) {
    (0, _classCallCheck2["default"])(this, ToggleSearchFocus);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
     * The dropdown instance
     * @type {Object}
     */
    this.dropdownTriggerEl = this.element_.querySelector(SELECTORS.DROPDOWN_TRIGGER);
    this.dropdownInstance_ = bootstrap.Dropdown.getOrCreateInstance(this.dropdownTriggerEl);
    this.dropdownMenuEl = this.element_.querySelector(SELECTORS.DROPDOWN_MENU);

    /**
     * Binds functions.
     */
    this.initialize_ = this.initialize_.bind(this);
    this.handleDropdownShown_ = this.handleDropdownShown_.bind(this);
    this.initialize_();
  }

  /**
   * Initializes the component.
   * @private
   */
  return (0, _createClass2["default"])(ToggleSearchFocus, [{
    key: "initialize_",
    value: function initialize_() {
      // Listen for the Bootstrap dropdown shown event
      this.element_.addEventListener("shown.bs.dropdown", this.handleDropdownShown_);
    }

    /**
     * Handles dropdown shown event
     * @param {Event} event - The dropdown shown event
     * @private
     */
  }, {
    key: "handleDropdownShown_",
    value: function handleDropdownShown_() {
      if (this.dropdownMenuEl) {
        // Find the input field within the dropdown
        var searchInput = this.dropdownMenuEl.querySelector(SELECTORS.INPUT);
        if (searchInput) {
          // Focus on the input with a slight delay to ensure the dropdown is fully shown
          setTimeout(function () {
            searchInput.focus();
          }, 50);
        }
      }
    }
  }]);
}();

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],24:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var UpdateInnerTextManager = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function UpdateInnerTextManager(element) {
    (0, _classCallCheck2["default"])(this, UpdateInnerTextManager);
    /**
     * Component main element.
     * @type {!Element}
     */
    this.element_ = element;

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.updateInnerTextHandler_ = this.updateInnerTextHandler_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(UpdateInnerTextManager, [{
    key: "initialize_",
    value: function initialize_() {
      var _this = this;
      this.element_.addEventListener("updateInnerText", function (event) {
        return _this.updateInnerTextHandler_(event);
      });
    }

    /**
     * update the target innerText
     * @param {Object} event
     */
  }, {
    key: "updateInnerTextHandler_",
    value: function updateInnerTextHandler_(event) {
      var _event$detail;
      this.element_.textContent = event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.innerText;
    }
  }]);
}();
var _default = exports["default"] = UpdateInnerTextManager;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],25:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * The component's selectors.
 */
var SELECTORS = {
  videoSrc: "data-video-src",
  modalEl: "data-bs-target",
  modaliFrame: "data-iframe"
};
var VideoModalSourceSetup = /*#__PURE__*/function () {
  /**
   * The constructor.
   * @param {*} element
   */
  function VideoModalSourceSetup(element) {
    (0, _classCallCheck2["default"])(this, VideoModalSourceSetup);
    /**
     * Component main element.
     * @type {!Element}
     */

    this.element_ = element;
    this.targetModalId_ = this.element_.getAttribute(SELECTORS.modalEl);
    this.videoModal_ = document.querySelector("".concat(this.targetModalId_));
    this.videoIFrame_ = this.videoModal_.querySelector("[".concat(SELECTORS.modaliFrame, "]"));

    /**
      * Binds functions.
      */
    this.initialize_ = this.initialize_.bind(this);
    this.setupModalVideoSrc_ = this.setupModalVideoSrc_.bind(this);
    this.clearVideoSrc_ = this.clearVideoSrc_.bind(this);
    this.initialize_();
  }

  /**
  * Initializes the component.
  * @private
  */
  return (0, _createClass2["default"])(VideoModalSourceSetup, [{
    key: "initialize_",
    value: function initialize_() {
      this.element_.addEventListener("click", this.setupModalVideoSrc_);
      this.videoModal_.addEventListener("hide.bs.modal", this.clearVideoSrc_);
    }

    /**
     * sets up video link
     * @private
     */
  }, {
    key: "setupModalVideoSrc_",
    value: function setupModalVideoSrc_() {
      var playTargetSrc = this.element_.getAttribute(SELECTORS.videoSrc);
      this.videoIFrame_.setAttribute("src", playTargetSrc);
    }

    /**
    * Clears the video src to stop playing the video.
    * @private
    */
  }, {
    key: "clearVideoSrc_",
    value: function clearVideoSrc_() {
      this.videoIFrame_.setAttribute("src", "");
    }
  }]);
}();
var _default = exports["default"] = VideoModalSourceSetup;

},{"@babel/runtime/helpers/classCallCheck":31,"@babel/runtime/helpers/createClass":32,"@babel/runtime/helpers/interopRequireDefault":34}],26:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _initSwiper = _interopRequireDefault(require("./components/init-swiper"));
var _collapseBtnText = _interopRequireDefault(require("./components/collapse-btn-text"));
var _goPreviousPage = _interopRequireDefault(require("./components/go-previous-page"));
var _handleSubscribeModal = _interopRequireDefault(require("./components/handle-subscribe-modal"));
var _rightClickDisable = _interopRequireDefault(require("./components/right-click-disable"));
var _stickyHeader = _interopRequireDefault(require("./components/sticky-header"));
var _productList = _interopRequireDefault(require("./components/product-list"));
var _paymentMethod = _interopRequireDefault(require("./components/payment-method"));
var _paymentPageStepNavigator = _interopRequireDefault(require("./components/payment-page-step-navigator"));
var _productsLayoutAnimation = _interopRequireDefault(require("./components/products-layout-animation"));
var _productFavoriteManager = _interopRequireDefault(require("./components/product-favorite-manager"));
var _updateInnerTextManager = _interopRequireDefault(require("./components/update-inner-text-manager"));
var _productCartManager = _interopRequireDefault(require("./components/product-cart-manager"));
var _productListFilterSortForm = _interopRequireDefault(require("./components/product-list-filter-sort-form"));
var _countDownRedirect = _interopRequireDefault(require("./components/count-down-redirect"));
var _videoModalSourceSetup = _interopRequireDefault(require("./components/video-modal-source-setup"));
var _datepickerFlatpicker = _interopRequireDefault(require("./components/datepicker-flatpicker"));
var _foodCalculator = _interopRequireDefault(require("./components/food-calculator"));
var _handleStaticItemsShowMore = _interopRequireDefault(require("./components/handle-static-items-show-more"));
var _handleAdminRedeem = _interopRequireDefault(require("./components/handle-admin-redeem"));
var _paypalCore = _interopRequireDefault(require("./components/paypal-core"));
var _togglePassword = _interopRequireDefault(require("./components/toggle-password"));
var _toggleSearchFocus = _interopRequireDefault(require("./components/toggle-search-focus"));
function initBootstrapTooltip() {
  var tooltipTriggerList = document.querySelectorAll("[data-bs-toggle=\"tooltip\"]");
  (0, _toConsumableArray2["default"])(tooltipTriggerList).map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
}
function initStickyHeader() {
  document.querySelectorAll("[data-header=\"sticky\"]").forEach(function (element) {
    new _stickyHeader["default"](element);
  });
}
function initSuscribeModalShow() {
  document.querySelectorAll("[data-mlp-subscribe-modal='checkShow']").forEach(function (element) {
    new _handleSubscribeModal["default"](element);
  });
}
function initRightContextMenuDisable() {
  document.querySelectorAll("img").forEach(function (element) {
    (0, _rightClickDisable["default"])(element);
  });
}
function initCollapseText() {
  document.querySelectorAll("[data-collapse-text-update]").forEach(function (element) {
    (0, _collapseBtnText["default"])(element);
  });
}
function initGoPrevious() {
  document.querySelectorAll("[data-action=\"previous-page\"]").forEach(function (element) {
    new _goPreviousPage["default"](element);
  });
}
function initProductList() {
  document.querySelectorAll("[data-category-api]").forEach(function (element) {
    new _productList["default"](element);
  });
}
function initPaymentMethod() {
  document.querySelectorAll("[data-payment-method]").forEach(function (element) {
    new _paymentMethod["default"](element);
  });
}
function initPaymentPageStepNavigator() {
  document.querySelectorAll("[data-payment-page-step-navigator]").forEach(function (element) {
    new _paymentPageStepNavigator["default"](element);
  });
}
function initProductFavroite() {
  document.querySelectorAll("[data-action-favorite]").forEach(function (element) {
    new _productFavoriteManager["default"](element);
  });
}
function initWishlistCountEvent() {
  document.querySelectorAll("[data-event-inner-text]").forEach(function (element) {
    new _updateInnerTextManager["default"](element);
  });
}
function initProductThumbAddToCart() {
  document.querySelectorAll("[data-action-cart=\"add\"]").forEach(function (element) {
    new _productCartManager["default"](element);
  });
}
function productListFilterSortForm() {
  document.querySelectorAll("#query-parameters-form").forEach(function (element) {
    new _productListFilterSortForm["default"](element);
  });
}
function initProductsLayoutAnimation() {
  document.querySelectorAll("[data-action-layout='btn']").forEach(function (element) {
    new _productsLayoutAnimation["default"](element);
  });
}
function videoModalSetup() {
  document.querySelectorAll("[data-video-action='set']").forEach(function (element) {
    new _videoModalSourceSetup["default"](element);
  });
}
function initDatepickerFlatpicker() {
  document.querySelectorAll("[data-flatpicker]").forEach(function (element) {
    new _datepickerFlatpicker["default"](element);
  });
}
function initTogglePassword() {
  document.querySelectorAll("[data-click=\"togglePassword\"]").forEach(function (element) {
    new _togglePassword["default"](element);
  });
}
function formAutoSubmit() {
  document.querySelectorAll("[data-form-action=\"autoSubmit\"]").forEach(function (element) {
    if (element) {
      element.submit();
    }
  });
}
function initFoodCalculator() {
  document.querySelectorAll("[data-food-calculator='modal']").forEach(function (element) {
    new _foodCalculator["default"](element);
  });
}
function initStaticItemsShowMore() {
  document.querySelectorAll("[data-show-more='click']").forEach(function (element) {
    new _handleStaticItemsShowMore["default"](element);
  });
}
function initCountdownRedirect() {
  document.querySelectorAll("[data-redirect='/']").forEach(function (element) {
    new _countDownRedirect["default"](element);
  });
}
function initToggleSearchFocus() {
  document.querySelectorAll("[data-focus='toggleSearch']").forEach(function (element) {
    new _toggleSearchFocus["default"](element);
  });
}
function initAdminRedeem() {
  document.querySelectorAll("[data-mlp-forms=\"redeem\"]").forEach(function (element) {
    new _handleAdminRedeem["default"](element);
  });
}
function initPaypal() {
  document.querySelectorAll("[data-paypal-btn]").forEach(function (element) {
    (0, _paypalCore["default"])(element);
  });
}
window.addEventListener("DOMContentLoaded", function () {
  initBootstrapTooltip();
  (0, _initSwiper["default"])();
  initSuscribeModalShow();
  initRightContextMenuDisable();
  initStickyHeader();
  initCollapseText();
  initGoPrevious();
  initProductList();
  initPaymentMethod();
  initPaymentPageStepNavigator();
  initTogglePassword();
  initProductFavroite();
  initWishlistCountEvent();
  initProductThumbAddToCart();
  productListFilterSortForm();
  initProductsLayoutAnimation();
  initDatepickerFlatpicker();
  videoModalSetup();
  formAutoSubmit();
  initFoodCalculator();
  initStaticItemsShowMore();
  initCountdownRedirect();
  initToggleSearchFocus();
  initAdminRedeem();
  initPaypal();
});

},{"./components/collapse-btn-text":3,"./components/count-down-redirect":4,"./components/datepicker-flatpicker":5,"./components/food-calculator":6,"./components/go-previous-page":7,"./components/handle-admin-redeem":8,"./components/handle-static-items-show-more":9,"./components/handle-subscribe-modal":10,"./components/init-swiper":11,"./components/payment-method":12,"./components/payment-page-step-navigator":13,"./components/paypal-core":14,"./components/product-cart-manager":15,"./components/product-favorite-manager":16,"./components/product-list":18,"./components/product-list-filter-sort-form":17,"./components/products-layout-animation":19,"./components/right-click-disable":20,"./components/sticky-header":21,"./components/toggle-password":22,"./components/toggle-search-focus":23,"./components/update-inner-text-manager":24,"./components/video-modal-source-setup":25,"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/helpers/toConsumableArray":38}],27:[function(require,module,exports){
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelCaseAll = camelCaseAll;
exports.formatDateYYYYMMDD = formatDateYYYYMMDD;
exports.getCsrftoken = getCsrftoken;
exports.numberToFixTwo = numberToFixTwo;
exports.updateAllCartCountNumber = updateAllCartCountNumber;
exports.updateAllWishlistCountNumber = updateAllWishlistCountNumber;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function camelCaseAll(src) {
  var data = src;
  if (Array.isArray(src)) {
    data = src.map(function (obj) {
      return camelCaseAll(obj);
    });
  } else if ((0, _typeof2["default"])(src) === "object" && src !== null) {
    var keys = Object.keys(src);
    var transformedData = {};
    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      var key = _keys[_i];
      var camelCasedKey = key.replace(/_([a-z])/g, function (_, letter) {
        return letter.toUpperCase();
      });
      var fixedCamelCasedKey = camelCasedKey.charAt(0).toLowerCase() + camelCasedKey.slice(1);
      transformedData[fixedCamelCasedKey] = camelCaseAll(src[key]);
    }
    data = transformedData;
  }
  return data;
}
function getCsrftoken() {
  var cookieValue = null;
  if (document.getElementById("id-data-x-csrftoken")) {
    cookieValue = document.getElementById("id-data-x-csrftoken").getAttribute("content");
  }
  return cookieValue;
}
function numberToFixTwo(value) {
  if (typeof value === "number") {
    return Number.parseFloat(value).toFixed(2);
  } else {
    return "".concat(value, " is not a number");
  }
}
function updateAllWishlistCountNumber(updateEvent) {
  document.querySelectorAll("[data-event-inner-text=\"favoriteCount\"]").forEach(function (element_) {
    element_.dispatchEvent(updateEvent);
  });
}
function updateAllCartCountNumber(updateEvent) {
  document.querySelectorAll("[data-event-inner-text=\"cartCount\"]").forEach(function (element_) {
    element_.dispatchEvent(updateEvent);
  });
}
function formatDateYYYYMMDD(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var day = String(date.getDate()).padStart(2, "0");
  return "".concat(year, "-").concat(month, "-").concat(day);
}

},{"@babel/runtime/helpers/interopRequireDefault":34,"@babel/runtime/helpers/typeof":41}],28:[function(require,module,exports){
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],29:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":28}],30:[function(require,module,exports){
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],31:[function(require,module,exports){
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],32:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":40}],33:[function(require,module,exports){
var toPropertyKey = require("./toPropertyKey.js");
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPropertyKey.js":40}],34:[function(require,module,exports){
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],35:[function(require,module,exports){
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],36:[function(require,module,exports){
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],37:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":41}],38:[function(require,module,exports){
var arrayWithoutHoles = require("./arrayWithoutHoles.js");
var iterableToArray = require("./iterableToArray.js");
var unsupportedIterableToArray = require("./unsupportedIterableToArray.js");
var nonIterableSpread = require("./nonIterableSpread.js");
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayWithoutHoles.js":29,"./iterableToArray.js":35,"./nonIterableSpread.js":36,"./unsupportedIterableToArray.js":42}],39:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./typeof.js":41}],40:[function(require,module,exports){
var _typeof = require("./typeof.js")["default"];
var toPrimitive = require("./toPrimitive.js");
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./toPrimitive.js":39,"./typeof.js":41}],41:[function(require,module,exports){
function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{}],42:[function(require,module,exports){
var arrayLikeToArray = require("./arrayLikeToArray.js");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
},{"./arrayLikeToArray.js":28}],43:[function(require,module,exports){
// TODO(Babel 8): Remove this file.

var runtime = require("../helpers/regeneratorRuntime")();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}

},{"../helpers/regeneratorRuntime":37}],44:[function(require,module,exports){
/* flatpickr v4.6.13, @license MIT */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.flatpickr = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var HOOKS = [
        "onChange",
        "onClose",
        "onDayCreate",
        "onDestroy",
        "onKeyDown",
        "onMonthChange",
        "onOpen",
        "onParseConfig",
        "onReady",
        "onValueUpdate",
        "onYearChange",
        "onPreCalendarPosition",
    ];
    var defaults = {
        _disable: [],
        allowInput: false,
        allowInvalidPreload: false,
        altFormat: "F j, Y",
        altInput: false,
        altInputClass: "form-control input",
        animate: typeof window === "object" &&
            window.navigator.userAgent.indexOf("MSIE") === -1,
        ariaDateFormat: "F j, Y",
        autoFillDefaultTime: true,
        clickOpens: true,
        closeOnSelect: true,
        conjunction: ", ",
        dateFormat: "Y-m-d",
        defaultHour: 12,
        defaultMinute: 0,
        defaultSeconds: 0,
        disable: [],
        disableMobile: false,
        enableSeconds: false,
        enableTime: false,
        errorHandler: function (err) {
            return typeof console !== "undefined" && console.warn(err);
        },
        getWeek: function (givenDate) {
            var date = new Date(givenDate.getTime());
            date.setHours(0, 0, 0, 0);
            // Thursday in current week decides the year.
            date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
            // January 4 is always in week 1.
            var week1 = new Date(date.getFullYear(), 0, 4);
            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
            return (1 +
                Math.round(((date.getTime() - week1.getTime()) / 86400000 -
                    3 +
                    ((week1.getDay() + 6) % 7)) /
                    7));
        },
        hourIncrement: 1,
        ignoredFocusElements: [],
        inline: false,
        locale: "default",
        minuteIncrement: 5,
        mode: "single",
        monthSelectorType: "dropdown",
        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
        noCalendar: false,
        now: new Date(),
        onChange: [],
        onClose: [],
        onDayCreate: [],
        onDestroy: [],
        onKeyDown: [],
        onMonthChange: [],
        onOpen: [],
        onParseConfig: [],
        onReady: [],
        onValueUpdate: [],
        onYearChange: [],
        onPreCalendarPosition: [],
        plugins: [],
        position: "auto",
        positionElement: undefined,
        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
        shorthandCurrentMonth: false,
        showMonths: 1,
        static: false,
        time_24hr: false,
        weekNumbers: false,
        wrap: false,
    };

    var english = {
        weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
        },
        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        firstDayOfWeek: 0,
        ordinal: function (nth) {
            var s = nth % 100;
            if (s > 3 && s < 21)
                return "th";
            switch (s % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " to ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        amPM: ["AM", "PM"],
        yearAriaLabel: "Year",
        monthAriaLabel: "Month",
        hourAriaLabel: "Hour",
        minuteAriaLabel: "Minute",
        time_24hr: false,
    };

    var pad = function (number, length) {
        if (length === void 0) { length = 2; }
        return ("000" + number).slice(length * -1);
    };
    var int = function (bool) { return (bool === true ? 1 : 0); };
    /* istanbul ignore next */
    function debounce(fn, wait) {
        var t;
        return function () {
            var _this = this;
            var args = arguments;
            clearTimeout(t);
            t = setTimeout(function () { return fn.apply(_this, args); }, wait);
        };
    }
    var arrayify = function (obj) {
        return obj instanceof Array ? obj : [obj];
    };

    function toggleClass(elem, className, bool) {
        if (bool === true)
            return elem.classList.add(className);
        elem.classList.remove(className);
    }
    function createElement(tag, className, content) {
        var e = window.document.createElement(tag);
        className = className || "";
        content = content || "";
        e.className = className;
        if (content !== undefined)
            e.textContent = content;
        return e;
    }
    function clearNode(node) {
        while (node.firstChild)
            node.removeChild(node.firstChild);
    }
    function findParent(node, condition) {
        if (condition(node))
            return node;
        else if (node.parentNode)
            return findParent(node.parentNode, condition);
        return undefined; // nothing found
    }
    function createNumberInput(inputClassName, opts) {
        var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
        if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
            numInput.type = "number";
        }
        else {
            numInput.type = "text";
            numInput.pattern = "\\d*";
        }
        if (opts !== undefined)
            for (var key in opts)
                numInput.setAttribute(key, opts[key]);
        wrapper.appendChild(numInput);
        wrapper.appendChild(arrowUp);
        wrapper.appendChild(arrowDown);
        return wrapper;
    }
    function getEventTarget(event) {
        try {
            if (typeof event.composedPath === "function") {
                var path = event.composedPath();
                return path[0];
            }
            return event.target;
        }
        catch (error) {
            return event.target;
        }
    }

    var doNothing = function () { return undefined; };
    var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
    var revFormat = {
        D: doNothing,
        F: function (dateObj, monthName, locale) {
            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
        },
        G: function (dateObj, hour) {
            dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
        },
        H: function (dateObj, hour) {
            dateObj.setHours(parseFloat(hour));
        },
        J: function (dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        K: function (dateObj, amPM, locale) {
            dateObj.setHours((dateObj.getHours() % 12) +
                12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
        },
        M: function (dateObj, shortMonth, locale) {
            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
        },
        S: function (dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
        W: function (dateObj, weekNum, locale) {
            var weekNumber = parseInt(weekNum);
            var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
            date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
            return date;
        },
        Y: function (dateObj, year) {
            dateObj.setFullYear(parseFloat(year));
        },
        Z: function (_, ISODate) { return new Date(ISODate); },
        d: function (dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        h: function (dateObj, hour) {
            dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
        },
        i: function (dateObj, minutes) {
            dateObj.setMinutes(parseFloat(minutes));
        },
        j: function (dateObj, day) {
            dateObj.setDate(parseFloat(day));
        },
        l: doNothing,
        m: function (dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        n: function (dateObj, month) {
            dateObj.setMonth(parseFloat(month) - 1);
        },
        s: function (dateObj, seconds) {
            dateObj.setSeconds(parseFloat(seconds));
        },
        u: function (_, unixMillSeconds) {
            return new Date(parseFloat(unixMillSeconds));
        },
        w: doNothing,
        y: function (dateObj, year) {
            dateObj.setFullYear(2000 + parseFloat(year));
        },
    };
    var tokenRegex = {
        D: "",
        F: "",
        G: "(\\d\\d|\\d)",
        H: "(\\d\\d|\\d)",
        J: "(\\d\\d|\\d)\\w+",
        K: "",
        M: "",
        S: "(\\d\\d|\\d)",
        U: "(.+)",
        W: "(\\d\\d|\\d)",
        Y: "(\\d{4})",
        Z: "(.+)",
        d: "(\\d\\d|\\d)",
        h: "(\\d\\d|\\d)",
        i: "(\\d\\d|\\d)",
        j: "(\\d\\d|\\d)",
        l: "",
        m: "(\\d\\d|\\d)",
        n: "(\\d\\d|\\d)",
        s: "(\\d\\d|\\d)",
        u: "(.+)",
        w: "(\\d\\d|\\d)",
        y: "(\\d{2})",
    };
    var formats = {
        // get the date in UTC
        Z: function (date) { return date.toISOString(); },
        // weekday name, short, e.g. Thu
        D: function (date, locale, options) {
            return locale.weekdays.shorthand[formats.w(date, locale, options)];
        },
        // full month name e.g. January
        F: function (date, locale, options) {
            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
        },
        // padded hour 1-12
        G: function (date, locale, options) {
            return pad(formats.h(date, locale, options));
        },
        // hours with leading zero e.g. 03
        H: function (date) { return pad(date.getHours()); },
        // day (1-30) with ordinal suffix e.g. 1st, 2nd
        J: function (date, locale) {
            return locale.ordinal !== undefined
                ? date.getDate() + locale.ordinal(date.getDate())
                : date.getDate();
        },
        // AM/PM
        K: function (date, locale) { return locale.amPM[int(date.getHours() > 11)]; },
        // shorthand month e.g. Jan, Sep, Oct, etc
        M: function (date, locale) {
            return monthToStr(date.getMonth(), true, locale);
        },
        // seconds 00-59
        S: function (date) { return pad(date.getSeconds()); },
        // unix timestamp
        U: function (date) { return date.getTime() / 1000; },
        W: function (date, _, options) {
            return options.getWeek(date);
        },
        // full year e.g. 2016, padded (0001-9999)
        Y: function (date) { return pad(date.getFullYear(), 4); },
        // day in month, padded (01-30)
        d: function (date) { return pad(date.getDate()); },
        // hour from 1-12 (am/pm)
        h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
        // minutes, padded with leading zero e.g. 09
        i: function (date) { return pad(date.getMinutes()); },
        // day in month (1-30)
        j: function (date) { return date.getDate(); },
        // weekday name, full, e.g. Thursday
        l: function (date, locale) {
            return locale.weekdays.longhand[date.getDay()];
        },
        // padded month number (01-12)
        m: function (date) { return pad(date.getMonth() + 1); },
        // the month number (1-12)
        n: function (date) { return date.getMonth() + 1; },
        // seconds 0-59
        s: function (date) { return date.getSeconds(); },
        // Unix Milliseconds
        u: function (date) { return date.getTime(); },
        // number of the day of the week
        w: function (date) { return date.getDay(); },
        // last two digits of year e.g. 16 for 2016
        y: function (date) { return String(date.getFullYear()).substring(2); },
    };

    var createDateFormatter = function (_a) {
        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
        return function (dateObj, frmt, overrideLocale) {
            var locale = overrideLocale || l10n;
            if (config.formatDate !== undefined && !isMobile) {
                return config.formatDate(dateObj, frmt, locale);
            }
            return frmt
                .split("")
                .map(function (c, i, arr) {
                return formats[c] && arr[i - 1] !== "\\"
                    ? formats[c](dateObj, locale, config)
                    : c !== "\\"
                        ? c
                        : "";
            })
                .join("");
        };
    };
    var createDateParser = function (_a) {
        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
        return function (date, givenFormat, timeless, customLocale) {
            if (date !== 0 && !date)
                return undefined;
            var locale = customLocale || l10n;
            var parsedDate;
            var dateOrig = date;
            if (date instanceof Date)
                parsedDate = new Date(date.getTime());
            else if (typeof date !== "string" &&
                date.toFixed !== undefined // timestamp
            )
                // create a copy
                parsedDate = new Date(date);
            else if (typeof date === "string") {
                // date string
                var format = givenFormat || (config || defaults).dateFormat;
                var datestr = String(date).trim();
                if (datestr === "today") {
                    parsedDate = new Date();
                    timeless = true;
                }
                else if (config && config.parseDate) {
                    parsedDate = config.parseDate(date, format);
                }
                else if (/Z$/.test(datestr) ||
                    /GMT$/.test(datestr) // datestrings w/ timezone
                ) {
                    parsedDate = new Date(date);
                }
                else {
                    var matched = void 0, ops = [];
                    for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                        var token_1 = format[i];
                        var isBackSlash = token_1 === "\\";
                        var escaped = format[i - 1] === "\\" || isBackSlash;
                        if (tokenRegex[token_1] && !escaped) {
                            regexStr += tokenRegex[token_1];
                            var match = new RegExp(regexStr).exec(date);
                            if (match && (matched = true)) {
                                ops[token_1 !== "Y" ? "push" : "unshift"]({
                                    fn: revFormat[token_1],
                                    val: match[++matchIndex],
                                });
                            }
                        }
                        else if (!isBackSlash)
                            regexStr += "."; // don't really care
                    }
                    parsedDate =
                        !config || !config.noCalendar
                            ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
                            : new Date(new Date().setHours(0, 0, 0, 0));
                    ops.forEach(function (_a) {
                        var fn = _a.fn, val = _a.val;
                        return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
                    });
                    parsedDate = matched ? parsedDate : undefined;
                }
            }
            /* istanbul ignore next */
            if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
                return undefined;
            }
            if (timeless === true)
                parsedDate.setHours(0, 0, 0, 0);
            return parsedDate;
        };
    };
    /**
     * Compute the difference in dates, measured in ms
     */
    function compareDates(date1, date2, timeless) {
        if (timeless === void 0) { timeless = true; }
        if (timeless !== false) {
            return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
                new Date(date2.getTime()).setHours(0, 0, 0, 0));
        }
        return date1.getTime() - date2.getTime();
    }
    var isBetween = function (ts, ts1, ts2) {
        return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
    };
    var calculateSecondsSinceMidnight = function (hours, minutes, seconds) {
        return hours * 3600 + minutes * 60 + seconds;
    };
    var parseSeconds = function (secondsSinceMidnight) {
        var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
        return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
    };
    var duration = {
        DAY: 86400000,
    };
    function getDefaultHours(config) {
        var hours = config.defaultHour;
        var minutes = config.defaultMinute;
        var seconds = config.defaultSeconds;
        if (config.minDate !== undefined) {
            var minHour = config.minDate.getHours();
            var minMinutes = config.minDate.getMinutes();
            var minSeconds = config.minDate.getSeconds();
            if (hours < minHour) {
                hours = minHour;
            }
            if (hours === minHour && minutes < minMinutes) {
                minutes = minMinutes;
            }
            if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
                seconds = config.minDate.getSeconds();
        }
        if (config.maxDate !== undefined) {
            var maxHr = config.maxDate.getHours();
            var maxMinutes = config.maxDate.getMinutes();
            hours = Math.min(hours, maxHr);
            if (hours === maxHr)
                minutes = Math.min(maxMinutes, minutes);
            if (hours === maxHr && minutes === maxMinutes)
                seconds = config.maxDate.getSeconds();
        }
        return { hours: hours, minutes: minutes, seconds: seconds };
    }

    if (typeof Object.assign !== "function") {
        Object.assign = function (target) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (!target) {
                throw TypeError("Cannot convert undefined or null to object");
            }
            var _loop_1 = function (source) {
                if (source) {
                    Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
                }
            };
            for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
                var source = args_1[_a];
                _loop_1(source);
            }
            return target;
        };
    }

    var DEBOUNCED_CHANGE_MS = 300;
    function FlatpickrInstance(element, instanceConfig) {
        var self = {
            config: __assign(__assign({}, defaults), flatpickr.defaultConfig),
            l10n: english,
        };
        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
        self._handlers = [];
        self.pluginElements = [];
        self.loadedPlugins = [];
        self._bind = bind;
        self._setHoursFromDate = setHoursFromDate;
        self._positionCalendar = positionCalendar;
        self.changeMonth = changeMonth;
        self.changeYear = changeYear;
        self.clear = clear;
        self.close = close;
        self.onMouseOver = onMouseOver;
        self._createElement = createElement;
        self.createDay = createDay;
        self.destroy = destroy;
        self.isEnabled = isEnabled;
        self.jumpToDate = jumpToDate;
        self.updateValue = updateValue;
        self.open = open;
        self.redraw = redraw;
        self.set = set;
        self.setDate = setDate;
        self.toggle = toggle;
        function setupHelperFunctions() {
            self.utils = {
                getDaysInMonth: function (month, yr) {
                    if (month === void 0) { month = self.currentMonth; }
                    if (yr === void 0) { yr = self.currentYear; }
                    if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
                        return 29;
                    return self.l10n.daysInMonth[month];
                },
            };
        }
        function init() {
            self.element = self.input = element;
            self.isOpen = false;
            parseConfig();
            setupLocale();
            setupInputs();
            setupDates();
            setupHelperFunctions();
            if (!self.isMobile)
                build();
            bindEvents();
            if (self.selectedDates.length || self.config.noCalendar) {
                if (self.config.enableTime) {
                    setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
                }
                updateValue(false);
            }
            setCalendarWidth();
            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            /* TODO: investigate this further
        
              Currently, there is weird positioning behavior in safari causing pages
              to scroll up. https://github.com/chmln/flatpickr/issues/563
        
              However, most browsers are not Safari and positioning is expensive when used
              in scale. https://github.com/chmln/flatpickr/issues/1096
            */
            if (!self.isMobile && isSafari) {
                positionCalendar();
            }
            triggerEvent("onReady");
        }
        function getClosestActiveElement() {
            var _a;
            return (((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode())
                .activeElement || document.activeElement);
        }
        function bindToInstance(fn) {
            return fn.bind(self);
        }
        function setCalendarWidth() {
            var config = self.config;
            if (config.weekNumbers === false && config.showMonths === 1) {
                return;
            }
            else if (config.noCalendar !== true) {
                window.requestAnimationFrame(function () {
                    if (self.calendarContainer !== undefined) {
                        self.calendarContainer.style.visibility = "hidden";
                        self.calendarContainer.style.display = "block";
                    }
                    if (self.daysContainer !== undefined) {
                        var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                        self.daysContainer.style.width = daysWidth + "px";
                        self.calendarContainer.style.width =
                            daysWidth +
                                (self.weekWrapper !== undefined
                                    ? self.weekWrapper.offsetWidth
                                    : 0) +
                                "px";
                        self.calendarContainer.style.removeProperty("visibility");
                        self.calendarContainer.style.removeProperty("display");
                    }
                });
            }
        }
        /**
         * The handler for all events targeting the time inputs
         */
        function updateTime(e) {
            if (self.selectedDates.length === 0) {
                var defaultDate = self.config.minDate === undefined ||
                    compareDates(new Date(), self.config.minDate) >= 0
                    ? new Date()
                    : new Date(self.config.minDate.getTime());
                var defaults = getDefaultHours(self.config);
                defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
                self.selectedDates = [defaultDate];
                self.latestSelectedDateObj = defaultDate;
            }
            if (e !== undefined && e.type !== "blur") {
                timeWrapper(e);
            }
            var prevValue = self._input.value;
            setHoursFromInputs();
            updateValue();
            if (self._input.value !== prevValue) {
                self._debouncedChange();
            }
        }
        function ampm2military(hour, amPM) {
            return (hour % 12) + 12 * int(amPM === self.l10n.amPM[1]);
        }
        function military2ampm(hour) {
            switch (hour % 24) {
                case 0:
                case 12:
                    return 12;
                default:
                    return hour % 12;
            }
        }
        /**
         * Syncs the selected date object time with user's time input
         */
        function setHoursFromInputs() {
            if (self.hourElement === undefined || self.minuteElement === undefined)
                return;
            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
                ? (parseInt(self.secondElement.value, 10) || 0) % 60
                : 0;
            if (self.amPM !== undefined) {
                hours = ampm2military(hours, self.amPM.textContent);
            }
            var limitMinHours = self.config.minTime !== undefined ||
                (self.config.minDate &&
                    self.minDateHasTime &&
                    self.latestSelectedDateObj &&
                    compareDates(self.latestSelectedDateObj, self.config.minDate, true) ===
                        0);
            var limitMaxHours = self.config.maxTime !== undefined ||
                (self.config.maxDate &&
                    self.maxDateHasTime &&
                    self.latestSelectedDateObj &&
                    compareDates(self.latestSelectedDateObj, self.config.maxDate, true) ===
                        0);
            if (self.config.maxTime !== undefined &&
                self.config.minTime !== undefined &&
                self.config.minTime > self.config.maxTime) {
                var minBound = calculateSecondsSinceMidnight(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
                var maxBound = calculateSecondsSinceMidnight(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
                var currentTime = calculateSecondsSinceMidnight(hours, minutes, seconds);
                if (currentTime > maxBound && currentTime < minBound) {
                    var result = parseSeconds(minBound);
                    hours = result[0];
                    minutes = result[1];
                    seconds = result[2];
                }
            }
            else {
                if (limitMaxHours) {
                    var maxTime = self.config.maxTime !== undefined
                        ? self.config.maxTime
                        : self.config.maxDate;
                    hours = Math.min(hours, maxTime.getHours());
                    if (hours === maxTime.getHours())
                        minutes = Math.min(minutes, maxTime.getMinutes());
                    if (minutes === maxTime.getMinutes())
                        seconds = Math.min(seconds, maxTime.getSeconds());
                }
                if (limitMinHours) {
                    var minTime = self.config.minTime !== undefined
                        ? self.config.minTime
                        : self.config.minDate;
                    hours = Math.max(hours, minTime.getHours());
                    if (hours === minTime.getHours() && minutes < minTime.getMinutes())
                        minutes = minTime.getMinutes();
                    if (minutes === minTime.getMinutes())
                        seconds = Math.max(seconds, minTime.getSeconds());
                }
            }
            setHours(hours, minutes, seconds);
        }
        /**
         * Syncs time input values with a date
         */
        function setHoursFromDate(dateObj) {
            var date = dateObj || self.latestSelectedDateObj;
            if (date && date instanceof Date) {
                setHours(date.getHours(), date.getMinutes(), date.getSeconds());
            }
        }
        /**
         * Sets the hours, minutes, and optionally seconds
         * of the latest selected date object and the
         * corresponding time inputs
         * @param {Number} hours the hour. whether its military
         *                 or am-pm gets inferred from config
         * @param {Number} minutes the minutes
         * @param {Number} seconds the seconds (optional)
         */
        function setHours(hours, minutes, seconds) {
            if (self.latestSelectedDateObj !== undefined) {
                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
            }
            if (!self.hourElement || !self.minuteElement || self.isMobile)
                return;
            self.hourElement.value = pad(!self.config.time_24hr
                ? ((12 + hours) % 12) + 12 * int(hours % 12 === 0)
                : hours);
            self.minuteElement.value = pad(minutes);
            if (self.amPM !== undefined)
                self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
            if (self.secondElement !== undefined)
                self.secondElement.value = pad(seconds);
        }
        /**
         * Handles the year input and incrementing events
         * @param {Event} event the keyup or increment event
         */
        function onYearInput(event) {
            var eventTarget = getEventTarget(event);
            var year = parseInt(eventTarget.value) + (event.delta || 0);
            if (year / 1000 > 1 ||
                (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
                changeYear(year);
            }
        }
        /**
         * Essentially addEventListener + tracking
         * @param {Element} element the element to addEventListener to
         * @param {String} event the event name
         * @param {Function} handler the event handler
         */
        function bind(element, event, handler, options) {
            if (event instanceof Array)
                return event.forEach(function (ev) { return bind(element, ev, handler, options); });
            if (element instanceof Array)
                return element.forEach(function (el) { return bind(el, event, handler, options); });
            element.addEventListener(event, handler, options);
            self._handlers.push({
                remove: function () { return element.removeEventListener(event, handler, options); },
            });
        }
        function triggerChange() {
            triggerEvent("onChange");
        }
        /**
         * Adds all the necessary event listeners
         */
        function bindEvents() {
            if (self.config.wrap) {
                ["open", "close", "toggle", "clear"].forEach(function (evt) {
                    Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
                        return bind(el, "click", self[evt]);
                    });
                });
            }
            if (self.isMobile) {
                setupMobile();
                return;
            }
            var debouncedResize = debounce(onResize, 50);
            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
                bind(self.daysContainer, "mouseover", function (e) {
                    if (self.config.mode === "range")
                        onMouseOver(getEventTarget(e));
                });
            bind(self._input, "keydown", onKeyDown);
            if (self.calendarContainer !== undefined) {
                bind(self.calendarContainer, "keydown", onKeyDown);
            }
            if (!self.config.inline && !self.config.static)
                bind(window, "resize", debouncedResize);
            if (window.ontouchstart !== undefined)
                bind(window.document, "touchstart", documentClick);
            else
                bind(window.document, "mousedown", documentClick);
            bind(window.document, "focus", documentClick, { capture: true });
            if (self.config.clickOpens === true) {
                bind(self._input, "focus", self.open);
                bind(self._input, "click", self.open);
            }
            if (self.daysContainer !== undefined) {
                bind(self.monthNav, "click", onMonthNavClick);
                bind(self.monthNav, ["keyup", "increment"], onYearInput);
                bind(self.daysContainer, "click", selectDate);
            }
            if (self.timeContainer !== undefined &&
                self.minuteElement !== undefined &&
                self.hourElement !== undefined) {
                var selText = function (e) {
                    return getEventTarget(e).select();
                };
                bind(self.timeContainer, ["increment"], updateTime);
                bind(self.timeContainer, "blur", updateTime, { capture: true });
                bind(self.timeContainer, "click", timeIncrement);
                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
                if (self.secondElement !== undefined)
                    bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
                if (self.amPM !== undefined) {
                    bind(self.amPM, "click", function (e) {
                        updateTime(e);
                    });
                }
            }
            if (self.config.allowInput) {
                bind(self._input, "blur", onBlur);
            }
        }
        /**
         * Set the calendar view to a particular date.
         * @param {Date} jumpDate the date to set the view to
         * @param {boolean} triggerChange if change events should be triggered
         */
        function jumpToDate(jumpDate, triggerChange) {
            var jumpTo = jumpDate !== undefined
                ? self.parseDate(jumpDate)
                : self.latestSelectedDateObj ||
                    (self.config.minDate && self.config.minDate > self.now
                        ? self.config.minDate
                        : self.config.maxDate && self.config.maxDate < self.now
                            ? self.config.maxDate
                            : self.now);
            var oldYear = self.currentYear;
            var oldMonth = self.currentMonth;
            try {
                if (jumpTo !== undefined) {
                    self.currentYear = jumpTo.getFullYear();
                    self.currentMonth = jumpTo.getMonth();
                }
            }
            catch (e) {
                /* istanbul ignore next */
                e.message = "Invalid date supplied: " + jumpTo;
                self.config.errorHandler(e);
            }
            if (triggerChange && self.currentYear !== oldYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            if (triggerChange &&
                (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
                triggerEvent("onMonthChange");
            }
            self.redraw();
        }
        /**
         * The up/down arrow handler for time inputs
         * @param {Event} e the click event
         */
        function timeIncrement(e) {
            var eventTarget = getEventTarget(e);
            if (~eventTarget.className.indexOf("arrow"))
                incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
        }
        /**
         * Increments/decrements the value of input associ-
         * ated with the up/down arrow by dispatching an
         * "increment" event on the input.
         *
         * @param {Event} e the click event
         * @param {Number} delta the diff (usually 1 or -1)
         * @param {Element} inputElem the input element
         */
        function incrementNumInput(e, delta, inputElem) {
            var target = e && getEventTarget(e);
            var input = inputElem ||
                (target && target.parentNode && target.parentNode.firstChild);
            var event = createEvent("increment");
            event.delta = delta;
            input && input.dispatchEvent(event);
        }
        function build() {
            var fragment = window.document.createDocumentFragment();
            self.calendarContainer = createElement("div", "flatpickr-calendar");
            self.calendarContainer.tabIndex = -1;
            if (!self.config.noCalendar) {
                fragment.appendChild(buildMonthNav());
                self.innerContainer = createElement("div", "flatpickr-innerContainer");
                if (self.config.weekNumbers) {
                    var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                    self.innerContainer.appendChild(weekWrapper);
                    self.weekNumbers = weekNumbers;
                    self.weekWrapper = weekWrapper;
                }
                self.rContainer = createElement("div", "flatpickr-rContainer");
                self.rContainer.appendChild(buildWeekdays());
                if (!self.daysContainer) {
                    self.daysContainer = createElement("div", "flatpickr-days");
                    self.daysContainer.tabIndex = -1;
                }
                buildDays();
                self.rContainer.appendChild(self.daysContainer);
                self.innerContainer.appendChild(self.rContainer);
                fragment.appendChild(self.innerContainer);
            }
            if (self.config.enableTime) {
                fragment.appendChild(buildTime());
            }
            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
            toggleClass(self.calendarContainer, "animate", self.config.animate === true);
            toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
            self.calendarContainer.appendChild(fragment);
            var customAppend = self.config.appendTo !== undefined &&
                self.config.appendTo.nodeType !== undefined;
            if (self.config.inline || self.config.static) {
                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
                if (self.config.inline) {
                    if (!customAppend && self.element.parentNode)
                        self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                    else if (self.config.appendTo !== undefined)
                        self.config.appendTo.appendChild(self.calendarContainer);
                }
                if (self.config.static) {
                    var wrapper = createElement("div", "flatpickr-wrapper");
                    if (self.element.parentNode)
                        self.element.parentNode.insertBefore(wrapper, self.element);
                    wrapper.appendChild(self.element);
                    if (self.altInput)
                        wrapper.appendChild(self.altInput);
                    wrapper.appendChild(self.calendarContainer);
                }
            }
            if (!self.config.static && !self.config.inline)
                (self.config.appendTo !== undefined
                    ? self.config.appendTo
                    : window.document.body).appendChild(self.calendarContainer);
        }
        function createDay(className, date, _dayNumber, i) {
            var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", className, date.getDate().toString());
            dayElement.dateObj = date;
            dayElement.$i = i;
            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
            if (className.indexOf("hidden") === -1 &&
                compareDates(date, self.now) === 0) {
                self.todayDateElem = dayElement;
                dayElement.classList.add("today");
                dayElement.setAttribute("aria-current", "date");
            }
            if (dateIsEnabled) {
                dayElement.tabIndex = -1;
                if (isDateSelected(date)) {
                    dayElement.classList.add("selected");
                    self.selectedDateElem = dayElement;
                    if (self.config.mode === "range") {
                        toggleClass(dayElement, "startRange", self.selectedDates[0] &&
                            compareDates(date, self.selectedDates[0], true) === 0);
                        toggleClass(dayElement, "endRange", self.selectedDates[1] &&
                            compareDates(date, self.selectedDates[1], true) === 0);
                        if (className === "nextMonthDay")
                            dayElement.classList.add("inRange");
                    }
                }
            }
            else {
                dayElement.classList.add("flatpickr-disabled");
            }
            if (self.config.mode === "range") {
                if (isDateInRange(date) && !isDateSelected(date))
                    dayElement.classList.add("inRange");
            }
            if (self.weekNumbers &&
                self.config.showMonths === 1 &&
                className !== "prevMonthDay" &&
                i % 7 === 6) {
                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
            }
            triggerEvent("onDayCreate", dayElement);
            return dayElement;
        }
        function focusOnDayElem(targetNode) {
            targetNode.focus();
            if (self.config.mode === "range")
                onMouseOver(targetNode);
        }
        function getFirstAvailableDay(delta) {
            var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
            var endMonth = delta > 0 ? self.config.showMonths : -1;
            for (var m = startMonth; m != endMonth; m += delta) {
                var month = self.daysContainer.children[m];
                var startIndex = delta > 0 ? 0 : month.children.length - 1;
                var endIndex = delta > 0 ? month.children.length : -1;
                for (var i = startIndex; i != endIndex; i += delta) {
                    var c = month.children[i];
                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
                        return c;
                }
            }
            return undefined;
        }
        function getNextAvailableDay(current, delta) {
            var givenMonth = current.className.indexOf("Month") === -1
                ? current.dateObj.getMonth()
                : self.currentMonth;
            var endMonth = delta > 0 ? self.config.showMonths : -1;
            var loopDelta = delta > 0 ? 1 : -1;
            for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
                var month = self.daysContainer.children[m];
                var startIndex = givenMonth - self.currentMonth === m
                    ? current.$i + delta
                    : delta < 0
                        ? month.children.length - 1
                        : 0;
                var numMonthDays = month.children.length;
                for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
                    var c = month.children[i];
                    if (c.className.indexOf("hidden") === -1 &&
                        isEnabled(c.dateObj) &&
                        Math.abs(current.$i - i) >= Math.abs(delta))
                        return focusOnDayElem(c);
                }
            }
            self.changeMonth(loopDelta);
            focusOnDay(getFirstAvailableDay(loopDelta), 0);
            return undefined;
        }
        function focusOnDay(current, offset) {
            var activeElement = getClosestActiveElement();
            var dayFocused = isInView(activeElement || document.body);
            var startElem = current !== undefined
                ? current
                : dayFocused
                    ? activeElement
                    : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
                        ? self.selectedDateElem
                        : self.todayDateElem !== undefined && isInView(self.todayDateElem)
                            ? self.todayDateElem
                            : getFirstAvailableDay(offset > 0 ? 1 : -1);
            if (startElem === undefined) {
                self._input.focus();
            }
            else if (!dayFocused) {
                focusOnDayElem(startElem);
            }
            else {
                getNextAvailableDay(startElem, offset);
            }
        }
        function buildMonthDays(year, month) {
            var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
            var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
            var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
            var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
            // prepend days from the ending of previous month
            for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
                days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
            }
            // Start at 1 since there is no 0th day
            for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
                days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
            }
            // append days from the next month
            for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
                (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
                days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
            }
            //updateNavigationCurrentMonth();
            var dayContainer = createElement("div", "dayContainer");
            dayContainer.appendChild(days);
            return dayContainer;
        }
        function buildDays() {
            if (self.daysContainer === undefined) {
                return;
            }
            clearNode(self.daysContainer);
            // TODO: week numbers for each month
            if (self.weekNumbers)
                clearNode(self.weekNumbers);
            var frag = document.createDocumentFragment();
            for (var i = 0; i < self.config.showMonths; i++) {
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
            }
            self.daysContainer.appendChild(frag);
            self.days = self.daysContainer.firstChild;
            if (self.config.mode === "range" && self.selectedDates.length === 1) {
                onMouseOver();
            }
        }
        function buildMonthSwitch() {
            if (self.config.showMonths > 1 ||
                self.config.monthSelectorType !== "dropdown")
                return;
            var shouldBuildMonth = function (month) {
                if (self.config.minDate !== undefined &&
                    self.currentYear === self.config.minDate.getFullYear() &&
                    month < self.config.minDate.getMonth()) {
                    return false;
                }
                return !(self.config.maxDate !== undefined &&
                    self.currentYear === self.config.maxDate.getFullYear() &&
                    month > self.config.maxDate.getMonth());
            };
            self.monthsDropdownContainer.tabIndex = -1;
            self.monthsDropdownContainer.innerHTML = "";
            for (var i = 0; i < 12; i++) {
                if (!shouldBuildMonth(i))
                    continue;
                var month = createElement("option", "flatpickr-monthDropdown-month");
                month.value = new Date(self.currentYear, i).getMonth().toString();
                month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
                month.tabIndex = -1;
                if (self.currentMonth === i) {
                    month.selected = true;
                }
                self.monthsDropdownContainer.appendChild(month);
            }
        }
        function buildMonth() {
            var container = createElement("div", "flatpickr-month");
            var monthNavFragment = window.document.createDocumentFragment();
            var monthElement;
            if (self.config.showMonths > 1 ||
                self.config.monthSelectorType === "static") {
                monthElement = createElement("span", "cur-month");
            }
            else {
                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
                self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
                bind(self.monthsDropdownContainer, "change", function (e) {
                    var target = getEventTarget(e);
                    var selectedMonth = parseInt(target.value, 10);
                    self.changeMonth(selectedMonth - self.currentMonth);
                    triggerEvent("onMonthChange");
                });
                buildMonthSwitch();
                monthElement = self.monthsDropdownContainer;
            }
            var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
            var yearElement = yearInput.getElementsByTagName("input")[0];
            yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
            if (self.config.minDate) {
                yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
            }
            if (self.config.maxDate) {
                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
                yearElement.disabled =
                    !!self.config.minDate &&
                        self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
            }
            var currentMonth = createElement("div", "flatpickr-current-month");
            currentMonth.appendChild(monthElement);
            currentMonth.appendChild(yearInput);
            monthNavFragment.appendChild(currentMonth);
            container.appendChild(monthNavFragment);
            return {
                container: container,
                yearElement: yearElement,
                monthElement: monthElement,
            };
        }
        function buildMonths() {
            clearNode(self.monthNav);
            self.monthNav.appendChild(self.prevMonthNav);
            if (self.config.showMonths) {
                self.yearElements = [];
                self.monthElements = [];
            }
            for (var m = self.config.showMonths; m--;) {
                var month = buildMonth();
                self.yearElements.push(month.yearElement);
                self.monthElements.push(month.monthElement);
                self.monthNav.appendChild(month.container);
            }
            self.monthNav.appendChild(self.nextMonthNav);
        }
        function buildMonthNav() {
            self.monthNav = createElement("div", "flatpickr-months");
            self.yearElements = [];
            self.monthElements = [];
            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
            self.prevMonthNav.innerHTML = self.config.prevArrow;
            self.nextMonthNav = createElement("span", "flatpickr-next-month");
            self.nextMonthNav.innerHTML = self.config.nextArrow;
            buildMonths();
            Object.defineProperty(self, "_hidePrevMonthArrow", {
                get: function () { return self.__hidePrevMonthArrow; },
                set: function (bool) {
                    if (self.__hidePrevMonthArrow !== bool) {
                        toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
                        self.__hidePrevMonthArrow = bool;
                    }
                },
            });
            Object.defineProperty(self, "_hideNextMonthArrow", {
                get: function () { return self.__hideNextMonthArrow; },
                set: function (bool) {
                    if (self.__hideNextMonthArrow !== bool) {
                        toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
                        self.__hideNextMonthArrow = bool;
                    }
                },
            });
            self.currentYearElement = self.yearElements[0];
            updateNavigationCurrentMonth();
            return self.monthNav;
        }
        function buildTime() {
            self.calendarContainer.classList.add("hasTime");
            if (self.config.noCalendar)
                self.calendarContainer.classList.add("noCalendar");
            var defaults = getDefaultHours(self.config);
            self.timeContainer = createElement("div", "flatpickr-time");
            self.timeContainer.tabIndex = -1;
            var separator = createElement("span", "flatpickr-time-separator", ":");
            var hourInput = createNumberInput("flatpickr-hour", {
                "aria-label": self.l10n.hourAriaLabel,
            });
            self.hourElement = hourInput.getElementsByTagName("input")[0];
            var minuteInput = createNumberInput("flatpickr-minute", {
                "aria-label": self.l10n.minuteAriaLabel,
            });
            self.minuteElement = minuteInput.getElementsByTagName("input")[0];
            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
            self.hourElement.value = pad(self.latestSelectedDateObj
                ? self.latestSelectedDateObj.getHours()
                : self.config.time_24hr
                    ? defaults.hours
                    : military2ampm(defaults.hours));
            self.minuteElement.value = pad(self.latestSelectedDateObj
                ? self.latestSelectedDateObj.getMinutes()
                : defaults.minutes);
            self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
            self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
            self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
            self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
            self.hourElement.setAttribute("maxlength", "2");
            self.minuteElement.setAttribute("min", "0");
            self.minuteElement.setAttribute("max", "59");
            self.minuteElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild(hourInput);
            self.timeContainer.appendChild(separator);
            self.timeContainer.appendChild(minuteInput);
            if (self.config.time_24hr)
                self.timeContainer.classList.add("time24hr");
            if (self.config.enableSeconds) {
                self.timeContainer.classList.add("hasSeconds");
                var secondInput = createNumberInput("flatpickr-second");
                self.secondElement = secondInput.getElementsByTagName("input")[0];
                self.secondElement.value = pad(self.latestSelectedDateObj
                    ? self.latestSelectedDateObj.getSeconds()
                    : defaults.seconds);
                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
                self.secondElement.setAttribute("min", "0");
                self.secondElement.setAttribute("max", "59");
                self.secondElement.setAttribute("maxlength", "2");
                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
                self.timeContainer.appendChild(secondInput);
            }
            if (!self.config.time_24hr) {
                // add self.amPM if appropriate
                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj
                    ? self.hourElement.value
                    : self.config.defaultHour) > 11)]);
                self.amPM.title = self.l10n.toggleTitle;
                self.amPM.tabIndex = -1;
                self.timeContainer.appendChild(self.amPM);
            }
            return self.timeContainer;
        }
        function buildWeekdays() {
            if (!self.weekdayContainer)
                self.weekdayContainer = createElement("div", "flatpickr-weekdays");
            else
                clearNode(self.weekdayContainer);
            for (var i = self.config.showMonths; i--;) {
                var container = createElement("div", "flatpickr-weekdaycontainer");
                self.weekdayContainer.appendChild(container);
            }
            updateWeekdays();
            return self.weekdayContainer;
        }
        function updateWeekdays() {
            if (!self.weekdayContainer) {
                return;
            }
            var firstDayOfWeek = self.l10n.firstDayOfWeek;
            var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
                weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
            }
            for (var i = self.config.showMonths; i--;) {
                self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
            }
        }
        /* istanbul ignore next */
        function buildWeeks() {
            self.calendarContainer.classList.add("hasWeeks");
            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
            var weekNumbers = createElement("div", "flatpickr-weeks");
            weekWrapper.appendChild(weekNumbers);
            return {
                weekWrapper: weekWrapper,
                weekNumbers: weekNumbers,
            };
        }
        function changeMonth(value, isOffset) {
            if (isOffset === void 0) { isOffset = true; }
            var delta = isOffset ? value : value - self.currentMonth;
            if ((delta < 0 && self._hidePrevMonthArrow === true) ||
                (delta > 0 && self._hideNextMonthArrow === true))
                return;
            self.currentMonth += delta;
            if (self.currentMonth < 0 || self.currentMonth > 11) {
                self.currentYear += self.currentMonth > 11 ? 1 : -1;
                self.currentMonth = (self.currentMonth + 12) % 12;
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            buildDays();
            triggerEvent("onMonthChange");
            updateNavigationCurrentMonth();
        }
        function clear(triggerChangeEvent, toInitial) {
            if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
            if (toInitial === void 0) { toInitial = true; }
            self.input.value = "";
            if (self.altInput !== undefined)
                self.altInput.value = "";
            if (self.mobileInput !== undefined)
                self.mobileInput.value = "";
            self.selectedDates = [];
            self.latestSelectedDateObj = undefined;
            if (toInitial === true) {
                self.currentYear = self._initialDate.getFullYear();
                self.currentMonth = self._initialDate.getMonth();
            }
            if (self.config.enableTime === true) {
                var _a = getDefaultHours(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
                setHours(hours, minutes, seconds);
            }
            self.redraw();
            if (triggerChangeEvent)
                // triggerChangeEvent is true (default) or an Event
                triggerEvent("onChange");
        }
        function close() {
            self.isOpen = false;
            if (!self.isMobile) {
                if (self.calendarContainer !== undefined) {
                    self.calendarContainer.classList.remove("open");
                }
                if (self._input !== undefined) {
                    self._input.classList.remove("active");
                }
            }
            triggerEvent("onClose");
        }
        function destroy() {
            if (self.config !== undefined)
                triggerEvent("onDestroy");
            for (var i = self._handlers.length; i--;) {
                self._handlers[i].remove();
            }
            self._handlers = [];
            if (self.mobileInput) {
                if (self.mobileInput.parentNode)
                    self.mobileInput.parentNode.removeChild(self.mobileInput);
                self.mobileInput = undefined;
            }
            else if (self.calendarContainer && self.calendarContainer.parentNode) {
                if (self.config.static && self.calendarContainer.parentNode) {
                    var wrapper = self.calendarContainer.parentNode;
                    wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                    if (wrapper.parentNode) {
                        while (wrapper.firstChild)
                            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                        wrapper.parentNode.removeChild(wrapper);
                    }
                }
                else
                    self.calendarContainer.parentNode.removeChild(self.calendarContainer);
            }
            if (self.altInput) {
                self.input.type = "text";
                if (self.altInput.parentNode)
                    self.altInput.parentNode.removeChild(self.altInput);
                delete self.altInput;
            }
            if (self.input) {
                self.input.type = self.input._type;
                self.input.classList.remove("flatpickr-input");
                self.input.removeAttribute("readonly");
            }
            [
                "_showTimeInput",
                "latestSelectedDateObj",
                "_hideNextMonthArrow",
                "_hidePrevMonthArrow",
                "__hideNextMonthArrow",
                "__hidePrevMonthArrow",
                "isMobile",
                "isOpen",
                "selectedDateElem",
                "minDateHasTime",
                "maxDateHasTime",
                "days",
                "daysContainer",
                "_input",
                "_positionElement",
                "innerContainer",
                "rContainer",
                "monthNav",
                "todayDateElem",
                "calendarContainer",
                "weekdayContainer",
                "prevMonthNav",
                "nextMonthNav",
                "monthsDropdownContainer",
                "currentMonthElement",
                "currentYearElement",
                "navigationCurrentMonth",
                "selectedDateElem",
                "config",
            ].forEach(function (k) {
                try {
                    delete self[k];
                }
                catch (_) { }
            });
        }
        function isCalendarElem(elem) {
            return self.calendarContainer.contains(elem);
        }
        function documentClick(e) {
            if (self.isOpen && !self.config.inline) {
                var eventTarget_1 = getEventTarget(e);
                var isCalendarElement = isCalendarElem(eventTarget_1);
                var isInput = eventTarget_1 === self.input ||
                    eventTarget_1 === self.altInput ||
                    self.element.contains(eventTarget_1) ||
                    // web components
                    // e.path is not present in all browsers. circumventing typechecks
                    (e.path &&
                        e.path.indexOf &&
                        (~e.path.indexOf(self.input) ||
                            ~e.path.indexOf(self.altInput)));
                var lostFocus = !isInput &&
                    !isCalendarElement &&
                    !isCalendarElem(e.relatedTarget);
                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
                    return elem.contains(eventTarget_1);
                });
                if (lostFocus && isIgnored) {
                    if (self.config.allowInput) {
                        self.setDate(self._input.value, false, self.config.altInput
                            ? self.config.altFormat
                            : self.config.dateFormat);
                    }
                    if (self.timeContainer !== undefined &&
                        self.minuteElement !== undefined &&
                        self.hourElement !== undefined &&
                        self.input.value !== "" &&
                        self.input.value !== undefined) {
                        updateTime();
                    }
                    self.close();
                    if (self.config &&
                        self.config.mode === "range" &&
                        self.selectedDates.length === 1)
                        self.clear(false);
                }
            }
        }
        function changeYear(newYear) {
            if (!newYear ||
                (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
                (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
                return;
            var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
            self.currentYear = newYearNum || self.currentYear;
            if (self.config.maxDate &&
                self.currentYear === self.config.maxDate.getFullYear()) {
                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
            }
            else if (self.config.minDate &&
                self.currentYear === self.config.minDate.getFullYear()) {
                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
            }
            if (isNewYear) {
                self.redraw();
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
        }
        function isEnabled(date, timeless) {
            var _a;
            if (timeless === void 0) { timeless = true; }
            var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
            if ((self.config.minDate &&
                dateToCheck &&
                compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
                (self.config.maxDate &&
                    dateToCheck &&
                    compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
                return false;
            if (!self.config.enable && self.config.disable.length === 0)
                return true;
            if (dateToCheck === undefined)
                return false;
            var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
            for (var i = 0, d = void 0; i < array.length; i++) {
                d = array[i];
                if (typeof d === "function" &&
                    d(dateToCheck) // disabled by function
                )
                    return bool;
                else if (d instanceof Date &&
                    dateToCheck !== undefined &&
                    d.getTime() === dateToCheck.getTime())
                    // disabled by date
                    return bool;
                else if (typeof d === "string") {
                    // disabled by date string
                    var parsed = self.parseDate(d, undefined, true);
                    return parsed && parsed.getTime() === dateToCheck.getTime()
                        ? bool
                        : !bool;
                }
                else if (
                // disabled by range
                typeof d === "object" &&
                    dateToCheck !== undefined &&
                    d.from &&
                    d.to &&
                    dateToCheck.getTime() >= d.from.getTime() &&
                    dateToCheck.getTime() <= d.to.getTime())
                    return bool;
            }
            return !bool;
        }
        function isInView(elem) {
            if (self.daysContainer !== undefined)
                return (elem.className.indexOf("hidden") === -1 &&
                    elem.className.indexOf("flatpickr-disabled") === -1 &&
                    self.daysContainer.contains(elem));
            return false;
        }
        function onBlur(e) {
            var isInput = e.target === self._input;
            var valueChanged = self._input.value.trimEnd() !== getDateStr();
            if (isInput &&
                valueChanged &&
                !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
                self.setDate(self._input.value, true, e.target === self.altInput
                    ? self.config.altFormat
                    : self.config.dateFormat);
            }
        }
        function onKeyDown(e) {
            // e.key                      e.keyCode
            // "Backspace"                        8
            // "Tab"                              9
            // "Enter"                           13
            // "Escape"     (IE "Esc")           27
            // "ArrowLeft"  (IE "Left")          37
            // "ArrowUp"    (IE "Up")            38
            // "ArrowRight" (IE "Right")         39
            // "ArrowDown"  (IE "Down")          40
            // "Delete"     (IE "Del")           46
            var eventTarget = getEventTarget(e);
            var isInput = self.config.wrap
                ? element.contains(eventTarget)
                : eventTarget === self._input;
            var allowInput = self.config.allowInput;
            var allowKeydown = self.isOpen && (!allowInput || !isInput);
            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
            if (e.keyCode === 13 && isInput) {
                if (allowInput) {
                    self.setDate(self._input.value, true, eventTarget === self.altInput
                        ? self.config.altFormat
                        : self.config.dateFormat);
                    self.close();
                    return eventTarget.blur();
                }
                else {
                    self.open();
                }
            }
            else if (isCalendarElem(eventTarget) ||
                allowKeydown ||
                allowInlineKeydown) {
                var isTimeObj = !!self.timeContainer &&
                    self.timeContainer.contains(eventTarget);
                switch (e.keyCode) {
                    case 13:
                        if (isTimeObj) {
                            e.preventDefault();
                            updateTime();
                            focusAndClose();
                        }
                        else
                            selectDate(e);
                        break;
                    case 27: // escape
                        e.preventDefault();
                        focusAndClose();
                        break;
                    case 8:
                    case 46:
                        if (isInput && !self.config.allowInput) {
                            e.preventDefault();
                            self.clear();
                        }
                        break;
                    case 37:
                    case 39:
                        if (!isTimeObj && !isInput) {
                            e.preventDefault();
                            var activeElement = getClosestActiveElement();
                            if (self.daysContainer !== undefined &&
                                (allowInput === false ||
                                    (activeElement && isInView(activeElement)))) {
                                var delta_1 = e.keyCode === 39 ? 1 : -1;
                                if (!e.ctrlKey)
                                    focusOnDay(undefined, delta_1);
                                else {
                                    e.stopPropagation();
                                    changeMonth(delta_1);
                                    focusOnDay(getFirstAvailableDay(1), 0);
                                }
                            }
                        }
                        else if (self.hourElement)
                            self.hourElement.focus();
                        break;
                    case 38:
                    case 40:
                        e.preventDefault();
                        var delta = e.keyCode === 40 ? 1 : -1;
                        if ((self.daysContainer &&
                            eventTarget.$i !== undefined) ||
                            eventTarget === self.input ||
                            eventTarget === self.altInput) {
                            if (e.ctrlKey) {
                                e.stopPropagation();
                                changeYear(self.currentYear - delta);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                            else if (!isTimeObj)
                                focusOnDay(undefined, delta * 7);
                        }
                        else if (eventTarget === self.currentYearElement) {
                            changeYear(self.currentYear - delta);
                        }
                        else if (self.config.enableTime) {
                            if (!isTimeObj && self.hourElement)
                                self.hourElement.focus();
                            updateTime(e);
                            self._debouncedChange();
                        }
                        break;
                    case 9:
                        if (isTimeObj) {
                            var elems = [
                                self.hourElement,
                                self.minuteElement,
                                self.secondElement,
                                self.amPM,
                            ]
                                .concat(self.pluginElements)
                                .filter(function (x) { return x; });
                            var i = elems.indexOf(eventTarget);
                            if (i !== -1) {
                                var target = elems[i + (e.shiftKey ? -1 : 1)];
                                e.preventDefault();
                                (target || self._input).focus();
                            }
                        }
                        else if (!self.config.noCalendar &&
                            self.daysContainer &&
                            self.daysContainer.contains(eventTarget) &&
                            e.shiftKey) {
                            e.preventDefault();
                            self._input.focus();
                        }
                        break;
                }
            }
            if (self.amPM !== undefined && eventTarget === self.amPM) {
                switch (e.key) {
                    case self.l10n.amPM[0].charAt(0):
                    case self.l10n.amPM[0].charAt(0).toLowerCase():
                        self.amPM.textContent = self.l10n.amPM[0];
                        setHoursFromInputs();
                        updateValue();
                        break;
                    case self.l10n.amPM[1].charAt(0):
                    case self.l10n.amPM[1].charAt(0).toLowerCase():
                        self.amPM.textContent = self.l10n.amPM[1];
                        setHoursFromInputs();
                        updateValue();
                        break;
                }
            }
            if (isInput || isCalendarElem(eventTarget)) {
                triggerEvent("onKeyDown", e);
            }
        }
        function onMouseOver(elem, cellClass) {
            if (cellClass === void 0) { cellClass = "flatpickr-day"; }
            if (self.selectedDates.length !== 1 ||
                (elem &&
                    (!elem.classList.contains(cellClass) ||
                        elem.classList.contains("flatpickr-disabled"))))
                return;
            var hoverDate = elem
                ? elem.dateObj.getTime()
                : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
            var containsDisabled = false;
            var minRange = 0, maxRange = 0;
            for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
                if (!isEnabled(new Date(t), true)) {
                    containsDisabled =
                        containsDisabled || (t > rangeStartDate && t < rangeEndDate);
                    if (t < initialDate && (!minRange || t > minRange))
                        minRange = t;
                    else if (t > initialDate && (!maxRange || t < maxRange))
                        maxRange = t;
                }
            }
            var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
            hoverableCells.forEach(function (dayElem) {
                var date = dayElem.dateObj;
                var timestamp = date.getTime();
                var outOfRange = (minRange > 0 && timestamp < minRange) ||
                    (maxRange > 0 && timestamp > maxRange);
                if (outOfRange) {
                    dayElem.classList.add("notAllowed");
                    ["inRange", "startRange", "endRange"].forEach(function (c) {
                        dayElem.classList.remove(c);
                    });
                    return;
                }
                else if (containsDisabled && !outOfRange)
                    return;
                ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
                    dayElem.classList.remove(c);
                });
                if (elem !== undefined) {
                    elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
                        ? "startRange"
                        : "endRange");
                    if (initialDate < hoverDate && timestamp === initialDate)
                        dayElem.classList.add("startRange");
                    else if (initialDate > hoverDate && timestamp === initialDate)
                        dayElem.classList.add("endRange");
                    if (timestamp >= minRange &&
                        (maxRange === 0 || timestamp <= maxRange) &&
                        isBetween(timestamp, initialDate, hoverDate))
                        dayElem.classList.add("inRange");
                }
            });
        }
        function onResize() {
            if (self.isOpen && !self.config.static && !self.config.inline)
                positionCalendar();
        }
        function open(e, positionElement) {
            if (positionElement === void 0) { positionElement = self._positionElement; }
            if (self.isMobile === true) {
                if (e) {
                    e.preventDefault();
                    var eventTarget = getEventTarget(e);
                    if (eventTarget) {
                        eventTarget.blur();
                    }
                }
                if (self.mobileInput !== undefined) {
                    self.mobileInput.focus();
                    self.mobileInput.click();
                }
                triggerEvent("onOpen");
                return;
            }
            else if (self._input.disabled || self.config.inline) {
                return;
            }
            var wasOpen = self.isOpen;
            self.isOpen = true;
            if (!wasOpen) {
                self.calendarContainer.classList.add("open");
                self._input.classList.add("active");
                triggerEvent("onOpen");
                positionCalendar(positionElement);
            }
            if (self.config.enableTime === true && self.config.noCalendar === true) {
                if (self.config.allowInput === false &&
                    (e === undefined ||
                        !self.timeContainer.contains(e.relatedTarget))) {
                    setTimeout(function () { return self.hourElement.select(); }, 50);
                }
            }
        }
        function minMaxDateSetter(type) {
            return function (date) {
                var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
                if (dateObj !== undefined) {
                    self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
                        dateObj.getHours() > 0 ||
                            dateObj.getMinutes() > 0 ||
                            dateObj.getSeconds() > 0;
                }
                if (self.selectedDates) {
                    self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
                    if (!self.selectedDates.length && type === "min")
                        setHoursFromDate(dateObj);
                    updateValue();
                }
                if (self.daysContainer) {
                    redraw();
                    if (dateObj !== undefined)
                        self.currentYearElement[type] = dateObj.getFullYear().toString();
                    else
                        self.currentYearElement.removeAttribute(type);
                    self.currentYearElement.disabled =
                        !!inverseDateObj &&
                            dateObj !== undefined &&
                            inverseDateObj.getFullYear() === dateObj.getFullYear();
                }
            };
        }
        function parseConfig() {
            var boolOpts = [
                "wrap",
                "weekNumbers",
                "allowInput",
                "allowInvalidPreload",
                "clickOpens",
                "time_24hr",
                "enableTime",
                "noCalendar",
                "altInput",
                "shorthandCurrentMonth",
                "inline",
                "static",
                "enableSeconds",
                "disableMobile",
            ];
            var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
            var formats = {};
            self.config.parseDate = userConfig.parseDate;
            self.config.formatDate = userConfig.formatDate;
            Object.defineProperty(self.config, "enable", {
                get: function () { return self.config._enable; },
                set: function (dates) {
                    self.config._enable = parseDateRules(dates);
                },
            });
            Object.defineProperty(self.config, "disable", {
                get: function () { return self.config._disable; },
                set: function (dates) {
                    self.config._disable = parseDateRules(dates);
                },
            });
            var timeMode = userConfig.mode === "time";
            if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
                formats.dateFormat =
                    userConfig.noCalendar || timeMode
                        ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
                        : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
            }
            if (userConfig.altInput &&
                (userConfig.enableTime || timeMode) &&
                !userConfig.altFormat) {
                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
                formats.altFormat =
                    userConfig.noCalendar || timeMode
                        ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
                        : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
            }
            Object.defineProperty(self.config, "minDate", {
                get: function () { return self.config._minDate; },
                set: minMaxDateSetter("min"),
            });
            Object.defineProperty(self.config, "maxDate", {
                get: function () { return self.config._maxDate; },
                set: minMaxDateSetter("max"),
            });
            var minMaxTimeSetter = function (type) { return function (val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            }; };
            Object.defineProperty(self.config, "minTime", {
                get: function () { return self.config._minTime; },
                set: minMaxTimeSetter("min"),
            });
            Object.defineProperty(self.config, "maxTime", {
                get: function () { return self.config._maxTime; },
                set: minMaxTimeSetter("max"),
            });
            if (userConfig.mode === "time") {
                self.config.noCalendar = true;
                self.config.enableTime = true;
            }
            Object.assign(self.config, formats, userConfig);
            for (var i = 0; i < boolOpts.length; i++)
                // https://github.com/microsoft/TypeScript/issues/31663
                self.config[boolOpts[i]] =
                    self.config[boolOpts[i]] === true ||
                        self.config[boolOpts[i]] === "true";
            HOOKS.filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
            });
            self.isMobile =
                !self.config.disableMobile &&
                    !self.config.inline &&
                    self.config.mode === "single" &&
                    !self.config.disable.length &&
                    !self.config.enable &&
                    !self.config.weekNumbers &&
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            for (var i = 0; i < self.config.plugins.length; i++) {
                var pluginConf = self.config.plugins[i](self) || {};
                for (var key in pluginConf) {
                    if (HOOKS.indexOf(key) > -1) {
                        self.config[key] = arrayify(pluginConf[key])
                            .map(bindToInstance)
                            .concat(self.config[key]);
                    }
                    else if (typeof userConfig[key] === "undefined")
                        self.config[key] = pluginConf[key];
                }
            }
            if (!userConfig.altInputClass) {
                self.config.altInputClass =
                    getInputElem().className + " " + self.config.altInputClass;
            }
            triggerEvent("onParseConfig");
        }
        function getInputElem() {
            return self.config.wrap
                ? element.querySelector("[data-input]")
                : element;
        }
        function setupLocale() {
            if (typeof self.config.locale !== "object" &&
                typeof flatpickr.l10ns[self.config.locale] === "undefined")
                self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
            self.l10n = __assign(__assign({}, flatpickr.l10ns.default), (typeof self.config.locale === "object"
                ? self.config.locale
                : self.config.locale !== "default"
                    ? flatpickr.l10ns[self.config.locale]
                    : undefined));
            tokenRegex.D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
            tokenRegex.l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
            tokenRegex.M = "(" + self.l10n.months.shorthand.join("|") + ")";
            tokenRegex.F = "(" + self.l10n.months.longhand.join("|") + ")";
            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
            var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
            if (userConfig.time_24hr === undefined &&
                flatpickr.defaultConfig.time_24hr === undefined) {
                self.config.time_24hr = self.l10n.time_24hr;
            }
            self.formatDate = createDateFormatter(self);
            self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
        }
        function positionCalendar(customPositionElement) {
            if (typeof self.config.position === "function") {
                return void self.config.position(self, customPositionElement);
            }
            if (self.calendarContainer === undefined)
                return;
            triggerEvent("onPreCalendarPosition");
            var positionElement = customPositionElement || self._positionElement;
            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
                (configPosVertical !== "below" &&
                    distanceFromBottom < calendarHeight &&
                    inputBounds.top > calendarHeight);
            var top = window.pageYOffset +
                inputBounds.top +
                (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
            if (self.config.inline)
                return;
            var left = window.pageXOffset + inputBounds.left;
            var isCenter = false;
            var isRight = false;
            if (configPosHorizontal === "center") {
                left -= (calendarWidth - inputBounds.width) / 2;
                isCenter = true;
            }
            else if (configPosHorizontal === "right") {
                left -= calendarWidth - inputBounds.width;
                isRight = true;
            }
            toggleClass(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
            toggleClass(self.calendarContainer, "arrowCenter", isCenter);
            toggleClass(self.calendarContainer, "arrowRight", isRight);
            var right = window.document.body.offsetWidth -
                (window.pageXOffset + inputBounds.right);
            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
            var centerMost = right + calendarWidth > window.document.body.offsetWidth;
            toggleClass(self.calendarContainer, "rightMost", rightMost);
            if (self.config.static)
                return;
            self.calendarContainer.style.top = top + "px";
            if (!rightMost) {
                self.calendarContainer.style.left = left + "px";
                self.calendarContainer.style.right = "auto";
            }
            else if (!centerMost) {
                self.calendarContainer.style.left = "auto";
                self.calendarContainer.style.right = right + "px";
            }
            else {
                var doc = getDocumentStyleSheet();
                // some testing environments don't have css support
                if (doc === undefined)
                    return;
                var bodyWidth = window.document.body.offsetWidth;
                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
                var centerBefore = ".flatpickr-calendar.centerMost:before";
                var centerAfter = ".flatpickr-calendar.centerMost:after";
                var centerIndex = doc.cssRules.length;
                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
                toggleClass(self.calendarContainer, "rightMost", false);
                toggleClass(self.calendarContainer, "centerMost", true);
                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
                self.calendarContainer.style.left = centerLeft + "px";
                self.calendarContainer.style.right = "auto";
            }
        }
        function getDocumentStyleSheet() {
            var editableSheet = null;
            for (var i = 0; i < document.styleSheets.length; i++) {
                var sheet = document.styleSheets[i];
                if (!sheet.cssRules)
                    continue;
                try {
                    sheet.cssRules;
                }
                catch (err) {
                    continue;
                }
                editableSheet = sheet;
                break;
            }
            return editableSheet != null ? editableSheet : createStyleSheet();
        }
        function createStyleSheet() {
            var style = document.createElement("style");
            document.head.appendChild(style);
            return style.sheet;
        }
        function redraw() {
            if (self.config.noCalendar || self.isMobile)
                return;
            buildMonthSwitch();
            updateNavigationCurrentMonth();
            buildDays();
        }
        function focusAndClose() {
            self._input.focus();
            if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
                navigator.msMaxTouchPoints !== undefined) {
                // hack - bugs in the way IE handles focus keeps the calendar open
                setTimeout(self.close, 0);
            }
            else {
                self.close();
            }
        }
        function selectDate(e) {
            e.preventDefault();
            e.stopPropagation();
            var isSelectable = function (day) {
                return day.classList &&
                    day.classList.contains("flatpickr-day") &&
                    !day.classList.contains("flatpickr-disabled") &&
                    !day.classList.contains("notAllowed");
            };
            var t = findParent(getEventTarget(e), isSelectable);
            if (t === undefined)
                return;
            var target = t;
            var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
            var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
                selectedDate.getMonth() >
                    self.currentMonth + self.config.showMonths - 1) &&
                self.config.mode !== "range";
            self.selectedDateElem = target;
            if (self.config.mode === "single")
                self.selectedDates = [selectedDate];
            else if (self.config.mode === "multiple") {
                var selectedIndex = isDateSelected(selectedDate);
                if (selectedIndex)
                    self.selectedDates.splice(parseInt(selectedIndex), 1);
                else
                    self.selectedDates.push(selectedDate);
            }
            else if (self.config.mode === "range") {
                if (self.selectedDates.length === 2) {
                    self.clear(false, false);
                }
                self.latestSelectedDateObj = selectedDate;
                self.selectedDates.push(selectedDate);
                // unless selecting same date twice, sort ascendingly
                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
                    self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
            }
            setHoursFromInputs();
            if (shouldChangeMonth) {
                var isNewYear = self.currentYear !== selectedDate.getFullYear();
                self.currentYear = selectedDate.getFullYear();
                self.currentMonth = selectedDate.getMonth();
                if (isNewYear) {
                    triggerEvent("onYearChange");
                    buildMonthSwitch();
                }
                triggerEvent("onMonthChange");
            }
            updateNavigationCurrentMonth();
            buildDays();
            updateValue();
            // maintain focus
            if (!shouldChangeMonth &&
                self.config.mode !== "range" &&
                self.config.showMonths === 1)
                focusOnDayElem(target);
            else if (self.selectedDateElem !== undefined &&
                self.hourElement === undefined) {
                self.selectedDateElem && self.selectedDateElem.focus();
            }
            if (self.hourElement !== undefined)
                self.hourElement !== undefined && self.hourElement.focus();
            if (self.config.closeOnSelect) {
                var single = self.config.mode === "single" && !self.config.enableTime;
                var range = self.config.mode === "range" &&
                    self.selectedDates.length === 2 &&
                    !self.config.enableTime;
                if (single || range) {
                    focusAndClose();
                }
            }
            triggerChange();
        }
        var CALLBACKS = {
            locale: [setupLocale, updateWeekdays],
            showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
            minDate: [jumpToDate],
            maxDate: [jumpToDate],
            positionElement: [updatePositionElement],
            clickOpens: [
                function () {
                    if (self.config.clickOpens === true) {
                        bind(self._input, "focus", self.open);
                        bind(self._input, "click", self.open);
                    }
                    else {
                        self._input.removeEventListener("focus", self.open);
                        self._input.removeEventListener("click", self.open);
                    }
                },
            ],
        };
        function set(option, value) {
            if (option !== null && typeof option === "object") {
                Object.assign(self.config, option);
                for (var key in option) {
                    if (CALLBACKS[key] !== undefined)
                        CALLBACKS[key].forEach(function (x) { return x(); });
                }
            }
            else {
                self.config[option] = value;
                if (CALLBACKS[option] !== undefined)
                    CALLBACKS[option].forEach(function (x) { return x(); });
                else if (HOOKS.indexOf(option) > -1)
                    self.config[option] = arrayify(value);
            }
            self.redraw();
            updateValue(true);
        }
        function setSelectedDate(inputDate, format) {
            var dates = [];
            if (inputDate instanceof Array)
                dates = inputDate.map(function (d) { return self.parseDate(d, format); });
            else if (inputDate instanceof Date || typeof inputDate === "number")
                dates = [self.parseDate(inputDate, format)];
            else if (typeof inputDate === "string") {
                switch (self.config.mode) {
                    case "single":
                    case "time":
                        dates = [self.parseDate(inputDate, format)];
                        break;
                    case "multiple":
                        dates = inputDate
                            .split(self.config.conjunction)
                            .map(function (date) { return self.parseDate(date, format); });
                        break;
                    case "range":
                        dates = inputDate
                            .split(self.l10n.rangeSeparator)
                            .map(function (date) { return self.parseDate(date, format); });
                        break;
                }
            }
            else
                self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
            self.selectedDates = (self.config.allowInvalidPreload
                ? dates
                : dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); }));
            if (self.config.mode === "range")
                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
        }
        function setDate(date, triggerChange, format) {
            if (triggerChange === void 0) { triggerChange = false; }
            if (format === void 0) { format = self.config.dateFormat; }
            if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
                return self.clear(triggerChange);
            setSelectedDate(date, format);
            self.latestSelectedDateObj =
                self.selectedDates[self.selectedDates.length - 1];
            self.redraw();
            jumpToDate(undefined, triggerChange);
            setHoursFromDate();
            if (self.selectedDates.length === 0) {
                self.clear(false);
            }
            updateValue(triggerChange);
            if (triggerChange)
                triggerEvent("onChange");
        }
        function parseDateRules(arr) {
            return arr
                .slice()
                .map(function (rule) {
                if (typeof rule === "string" ||
                    typeof rule === "number" ||
                    rule instanceof Date) {
                    return self.parseDate(rule, undefined, true);
                }
                else if (rule &&
                    typeof rule === "object" &&
                    rule.from &&
                    rule.to)
                    return {
                        from: self.parseDate(rule.from, undefined),
                        to: self.parseDate(rule.to, undefined),
                    };
                return rule;
            })
                .filter(function (x) { return x; }); // remove falsy values
        }
        function setupDates() {
            self.selectedDates = [];
            self.now = self.parseDate(self.config.now) || new Date();
            // Workaround IE11 setting placeholder as the input's value
            var preloadedDate = self.config.defaultDate ||
                ((self.input.nodeName === "INPUT" ||
                    self.input.nodeName === "TEXTAREA") &&
                    self.input.placeholder &&
                    self.input.value === self.input.placeholder
                    ? null
                    : self.input.value);
            if (preloadedDate)
                setSelectedDate(preloadedDate, self.config.dateFormat);
            self._initialDate =
                self.selectedDates.length > 0
                    ? self.selectedDates[0]
                    : self.config.minDate &&
                        self.config.minDate.getTime() > self.now.getTime()
                        ? self.config.minDate
                        : self.config.maxDate &&
                            self.config.maxDate.getTime() < self.now.getTime()
                            ? self.config.maxDate
                            : self.now;
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
            if (self.selectedDates.length > 0)
                self.latestSelectedDateObj = self.selectedDates[0];
            if (self.config.minTime !== undefined)
                self.config.minTime = self.parseDate(self.config.minTime, "H:i");
            if (self.config.maxTime !== undefined)
                self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
            self.minDateHasTime =
                !!self.config.minDate &&
                    (self.config.minDate.getHours() > 0 ||
                        self.config.minDate.getMinutes() > 0 ||
                        self.config.minDate.getSeconds() > 0);
            self.maxDateHasTime =
                !!self.config.maxDate &&
                    (self.config.maxDate.getHours() > 0 ||
                        self.config.maxDate.getMinutes() > 0 ||
                        self.config.maxDate.getSeconds() > 0);
        }
        function setupInputs() {
            self.input = getInputElem();
            /* istanbul ignore next */
            if (!self.input) {
                self.config.errorHandler(new Error("Invalid input element specified"));
                return;
            }
            // hack: store previous type to restore it after destroy()
            self.input._type = self.input.type;
            self.input.type = "text";
            self.input.classList.add("flatpickr-input");
            self._input = self.input;
            if (self.config.altInput) {
                // replicate self.element
                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
                self._input = self.altInput;
                self.altInput.placeholder = self.input.placeholder;
                self.altInput.disabled = self.input.disabled;
                self.altInput.required = self.input.required;
                self.altInput.tabIndex = self.input.tabIndex;
                self.altInput.type = "text";
                self.input.setAttribute("type", "hidden");
                if (!self.config.static && self.input.parentNode)
                    self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
            }
            if (!self.config.allowInput)
                self._input.setAttribute("readonly", "readonly");
            updatePositionElement();
        }
        function updatePositionElement() {
            self._positionElement = self.config.positionElement || self._input;
        }
        function setupMobile() {
            var inputType = self.config.enableTime
                ? self.config.noCalendar
                    ? "time"
                    : "datetime-local"
                : "date";
            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
            self.mobileInput.tabIndex = 1;
            self.mobileInput.type = inputType;
            self.mobileInput.disabled = self.input.disabled;
            self.mobileInput.required = self.input.required;
            self.mobileInput.placeholder = self.input.placeholder;
            self.mobileFormatStr =
                inputType === "datetime-local"
                    ? "Y-m-d\\TH:i:S"
                    : inputType === "date"
                        ? "Y-m-d"
                        : "H:i:S";
            if (self.selectedDates.length > 0) {
                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
            }
            if (self.config.minDate)
                self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
            if (self.config.maxDate)
                self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
            if (self.input.getAttribute("step"))
                self.mobileInput.step = String(self.input.getAttribute("step"));
            self.input.type = "hidden";
            if (self.altInput !== undefined)
                self.altInput.type = "hidden";
            try {
                if (self.input.parentNode)
                    self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
            }
            catch (_a) { }
            bind(self.mobileInput, "change", function (e) {
                self.setDate(getEventTarget(e).value, false, self.mobileFormatStr);
                triggerEvent("onChange");
                triggerEvent("onClose");
            });
        }
        function toggle(e) {
            if (self.isOpen === true)
                return self.close();
            self.open(e);
        }
        function triggerEvent(event, data) {
            // If the instance has been destroyed already, all hooks have been removed
            if (self.config === undefined)
                return;
            var hooks = self.config[event];
            if (hooks !== undefined && hooks.length > 0) {
                for (var i = 0; hooks[i] && i < hooks.length; i++)
                    hooks[i](self.selectedDates, self.input.value, self, data);
            }
            if (event === "onChange") {
                self.input.dispatchEvent(createEvent("change"));
                // many front-end frameworks bind to the input event
                self.input.dispatchEvent(createEvent("input"));
            }
        }
        function createEvent(name) {
            var e = document.createEvent("Event");
            e.initEvent(name, true, true);
            return e;
        }
        function isDateSelected(date) {
            for (var i = 0; i < self.selectedDates.length; i++) {
                var selectedDate = self.selectedDates[i];
                if (selectedDate instanceof Date &&
                    compareDates(selectedDate, date) === 0)
                    return "" + i;
            }
            return false;
        }
        function isDateInRange(date) {
            if (self.config.mode !== "range" || self.selectedDates.length < 2)
                return false;
            return (compareDates(date, self.selectedDates[0]) >= 0 &&
                compareDates(date, self.selectedDates[1]) <= 0);
        }
        function updateNavigationCurrentMonth() {
            if (self.config.noCalendar || self.isMobile || !self.monthNav)
                return;
            self.yearElements.forEach(function (yearElement, i) {
                var d = new Date(self.currentYear, self.currentMonth, 1);
                d.setMonth(self.currentMonth + i);
                if (self.config.showMonths > 1 ||
                    self.config.monthSelectorType === "static") {
                    self.monthElements[i].textContent =
                        monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
                }
                else {
                    self.monthsDropdownContainer.value = d.getMonth().toString();
                }
                yearElement.value = d.getFullYear().toString();
            });
            self._hidePrevMonthArrow =
                self.config.minDate !== undefined &&
                    (self.currentYear === self.config.minDate.getFullYear()
                        ? self.currentMonth <= self.config.minDate.getMonth()
                        : self.currentYear < self.config.minDate.getFullYear());
            self._hideNextMonthArrow =
                self.config.maxDate !== undefined &&
                    (self.currentYear === self.config.maxDate.getFullYear()
                        ? self.currentMonth + 1 > self.config.maxDate.getMonth()
                        : self.currentYear > self.config.maxDate.getFullYear());
        }
        function getDateStr(specificFormat) {
            var format = specificFormat ||
                (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
            return self.selectedDates
                .map(function (dObj) { return self.formatDate(dObj, format); })
                .filter(function (d, i, arr) {
                return self.config.mode !== "range" ||
                    self.config.enableTime ||
                    arr.indexOf(d) === i;
            })
                .join(self.config.mode !== "range"
                ? self.config.conjunction
                : self.l10n.rangeSeparator);
        }
        /**
         * Updates the values of inputs associated with the calendar
         */
        function updateValue(triggerChange) {
            if (triggerChange === void 0) { triggerChange = true; }
            if (self.mobileInput !== undefined && self.mobileFormatStr) {
                self.mobileInput.value =
                    self.latestSelectedDateObj !== undefined
                        ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
                        : "";
            }
            self.input.value = getDateStr(self.config.dateFormat);
            if (self.altInput !== undefined) {
                self.altInput.value = getDateStr(self.config.altFormat);
            }
            if (triggerChange !== false)
                triggerEvent("onValueUpdate");
        }
        function onMonthNavClick(e) {
            var eventTarget = getEventTarget(e);
            var isPrevMonth = self.prevMonthNav.contains(eventTarget);
            var isNextMonth = self.nextMonthNav.contains(eventTarget);
            if (isPrevMonth || isNextMonth) {
                changeMonth(isPrevMonth ? -1 : 1);
            }
            else if (self.yearElements.indexOf(eventTarget) >= 0) {
                eventTarget.select();
            }
            else if (eventTarget.classList.contains("arrowUp")) {
                self.changeYear(self.currentYear + 1);
            }
            else if (eventTarget.classList.contains("arrowDown")) {
                self.changeYear(self.currentYear - 1);
            }
        }
        function timeWrapper(e) {
            e.preventDefault();
            var isKeyDown = e.type === "keydown", eventTarget = getEventTarget(e), input = eventTarget;
            if (self.amPM !== undefined && eventTarget === self.amPM) {
                self.amPM.textContent =
                    self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
            }
            var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
                (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
            var newValue = curValue + step * delta;
            if (typeof input.value !== "undefined" && input.value.length === 2) {
                var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
                if (newValue < min) {
                    newValue =
                        max +
                            newValue +
                            int(!isHourElem) +
                            (int(isHourElem) && int(!self.amPM));
                    if (isMinuteElem)
                        incrementNumInput(undefined, -1, self.hourElement);
                }
                else if (newValue > max) {
                    newValue =
                        input === self.hourElement ? newValue - max - int(!self.amPM) : min;
                    if (isMinuteElem)
                        incrementNumInput(undefined, 1, self.hourElement);
                }
                if (self.amPM &&
                    isHourElem &&
                    (step === 1
                        ? newValue + curValue === 23
                        : Math.abs(newValue - curValue) > step)) {
                    self.amPM.textContent =
                        self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
                }
                input.value = pad(newValue);
            }
        }
        init();
        return self;
    }
    /* istanbul ignore next */
    function _flatpickr(nodeList, config) {
        // static list
        var nodes = Array.prototype.slice
            .call(nodeList)
            .filter(function (x) { return x instanceof HTMLElement; });
        var instances = [];
        for (var i = 0; i < nodes.length; i++) {
            var node = nodes[i];
            try {
                if (node.getAttribute("data-fp-omit") !== null)
                    continue;
                if (node._flatpickr !== undefined) {
                    node._flatpickr.destroy();
                    node._flatpickr = undefined;
                }
                node._flatpickr = FlatpickrInstance(node, config || {});
                instances.push(node._flatpickr);
            }
            catch (e) {
                console.error(e);
            }
        }
        return instances.length === 1 ? instances[0] : instances;
    }
    /* istanbul ignore next */
    if (typeof HTMLElement !== "undefined" &&
        typeof HTMLCollection !== "undefined" &&
        typeof NodeList !== "undefined") {
        // browser env
        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
            return _flatpickr(this, config);
        };
        HTMLElement.prototype.flatpickr = function (config) {
            return _flatpickr([this], config);
        };
    }
    /* istanbul ignore next */
    var flatpickr = function (selector, config) {
        if (typeof selector === "string") {
            return _flatpickr(window.document.querySelectorAll(selector), config);
        }
        else if (selector instanceof Node) {
            return _flatpickr([selector], config);
        }
        else {
            return _flatpickr(selector, config);
        }
    };
    /* istanbul ignore next */
    flatpickr.defaultConfig = {};
    flatpickr.l10ns = {
        en: __assign({}, english),
        default: __assign({}, english),
    };
    flatpickr.localize = function (l10n) {
        flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
    };
    flatpickr.setDefaults = function (config) {
        flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
    };
    flatpickr.parseDate = createDateParser({});
    flatpickr.formatDate = createDateFormatter({});
    flatpickr.compareDates = compareDates;
    /* istanbul ignore next */
    if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
        jQuery.fn.flatpickr = function (config) {
            return _flatpickr(this, config);
        };
    }
    Date.prototype.fp_incr = function (days) {
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
    };
    if (typeof window !== "undefined") {
        window.flatpickr = flatpickr;
    }

    return flatpickr;

})));

},{}]},{},[26]);
